(function () {
  const storageKey = "lily-dulce-language";
  const supported = ["en", "ar"];
  const uaeBounds = {
    north: 26.45,
    south: 22.35,
    east: 56.55,
    west: 51.35,
  };
  const blockedDeliveryAreas = [
    {
      key: "al-ruways",
      name: "Al Ruways",
      nameAr: "الرويس",
      lat: 24.1,
      lng: 52.73,
      radiusKm: 58,
      aliases: [
        "Al Ruways",
        "Al Ruwais",
        "Ruwais",
        "Ruways",
        "Al Ruwais Industrial City",
        "Al Dhannah City",
        "Al Dhanna City",
        "Al Dhannah",
        "Al Dhanna",
        "Abu Dhabi Water and Electricity Authority",
        "Abu Dhabi Water and Electricity Authority TWP",
        "ADWEA TWP",
        "Baynounah",
        "Baynouna",
        "Barqa Al Soqour",
        "Barqa Al Soqour Protected Area",
        "Al Marmar Island",
        "Homor Island",
        "Al Khizaynah Island",
        "Sulayyah Island",
        "Diqalah Island",
        "Jilaa Al Sagheerah Island",
        "الرويس",
        "مدينة الظنة",
        "الظنة",
        "بينونة",
        "برقة الصقور",
        "جزيرة المرمر",
        "جزيرة الحمر",
        "الخيزنة",
        "جزيرة السلية",
        "جزيرة دقالة",
        "جزيرة جلاء الصغيره",
      ],
    },
    {
      key: "al-mirfa",
      name: "Al Mirfa",
      nameAr: "المرفأ",
      lat: 24.05,
      lng: 53.41,
      radiusKm: 20,
      aliases: ["Al Mirfa", "Mirfa", "Al Marfa", "المرفأ", "المرفا"],
    },
    {
      key: "ghiyathi",
      name: "Ghiyathi",
      nameAr: "غياثي",
      lat: 23.83,
      lng: 52.81,
      radiusKm: 36,
      aliases: [
        "Ghiyathi",
        "Ghayathi",
        "Gheyathi",
        "Maraba' Ghayathi",
        "Maraba' Ghiyathi",
        "Maraba Ghayathi",
        "Maraba Ghiyathi",
        "Ghayathi East 5",
        "Ghiyathi East 5",
        "Ghayathi South",
        "Ghiyathi South",
        "Bad' Mubarak",
        "Bad Mubarak",
        "Yaw Al Nadhrah",
        "Bida Hazza",
        "Bida Hazza' Protected Area",
        "غياثي",
        "مرابع غياثي",
        "غياثي شرق 5",
        "غياثي جنوب",
        "بدع مبارك",
        "ياو النضرة",
        "بيدا هزاع",
      ],
    },
    {
      key: "zayed-city",
      name: "Zayed City",
      nameAr: "مدينة زايد",
      lat: 23.65,
      lng: 53.71,
      radiusKm: 52,
      aliases: [
        "Zayed City",
        "Madinat Zayed",
        "Zayed City Al Dhafra",
        "Madinat Zayed Al Dhafra",
        "Baynounah City",
        "Baynouna City",
        "Al Bday'ah",
        "Al Bdayah",
        "Al Bedaiah",
        "Madinat Zayed Liwa Road",
        "MZW8",
        "MZE9",
        "MZW16",
        "MZE30",
        "MZE32",
        "MZW31",
        "MZW33",
        "MZW34",
        "MZW35",
        "Jarbub",
        "Qatar",
        "Mahdar Al Ramlah Al Wusta",
        "مدينة زايد",
        "مدينة زايد الظفرة",
        "بينونة مدينة",
        "البدية",
        "طريق مدينة زايد ليوا",
        "جربوب",
        "قطر",
        "محضر الرملة الوسطى",
      ],
    },
    {
      key: "asab",
      name: "Asab",
      nameAr: "عصب",
      lat: 23.24,
      lng: 54.43,
      radiusKm: 30,
      aliases: [
        "Asab",
        "Asab Clinic",
        "GASCO Asab",
        "Gasco Asab",
        "Al 'Azeezah",
        "Al Azeezah",
        "Al 'Azeezah 3",
        "Al Azeezah 3",
        "Al Azizah",
        "Al Azizah 3",
        "عصب",
        "عيادة عصب",
        "جاسكو عصب",
        "العزيزة",
        "العزيزة 3",
      ],
    },
    {
      key: "mzeerah-liwa",
      name: "Mzeer'ah / Liwa",
      nameAr: "مزيرعة / ليوا",
      lat: 23.08,
      lng: 53.77,
      radiusKm: 48,
      aliases: [
        "Mzeer'ah",
        "Mzeerah",
        "Mezaira'a",
        "Mezaira",
        "Seih Al Khair",
        "Seih Al Khayr",
        "Sabakha",
        "Mahdar Kayyah",
        "Mahdar Latir",
        "Mahdar Al Dhuwaiher",
        "Mahdar Al Dhuwaihir",
        "Mahdar Al Lyeef",
        "Mahdar Al Liyef",
        "Mahdar Muqab",
        "Mahdar Qutuf",
        "Mahdar Attab",
        "Mahdar Shah",
        "Mahdar Sabkha",
        "مزيرعة",
        "سيح الخير",
        "سبخة",
        "محضر كايه",
        "محضر لطير",
        "محضر الضويهر",
        "محضر اللييف",
        "محضر مقب",
        "محضر قطوف",
        "محضر عتاب",
        "محضر شاه",
        "محضر السبخة",
      ],
    },
    {
      key: "dalma-island",
      name: "Dalma Island",
      nameAr: "جزيرة دلما",
      lat: 24.5,
      lng: 52.32,
      radiusKm: 18,
      aliases: ["Dalma Island", "Delma Island", "Dalma", "Delma", "جزيرة دلما", "دلما"],
    },
    {
      key: "sir-baniyas-island",
      name: "Sir Baniyas Island",
      nameAr: "جزيرة صير بني ياس",
      lat: 24.31,
      lng: 52.6,
      radiusKm: 18,
      aliases: ["Sir Baniyas Island", "Sir Bani Yas Island", "Sir Baniyas", "Sir Bani Yas", "جزيرة صير بني ياس", "صير بني ياس"],
    },
    {
      key: "barakah",
      name: "Barakah",
      nameAr: "براكة",
      lat: 23.98,
      lng: 52.23,
      radiusKm: 22,
      aliases: [
        "Barakah",
        "Baraka",
        "ENEC Visitor Badging Office",
        "Enec Visitor Badging Office",
        "Butinah Restaurant",
        "Bu Tinah Restaurant",
        "براكة",
        "بركة",
        "مكتب تصاريح زوار إنيك",
        "مطعم بوطينة",
      ],
    },
    {
      key: "al-wiqan",
      name: "Al Wiqan",
      nameAr: "الوقن",
      lat: 23.63,
      lng: 55.55,
      radiusKm: 20,
      aliases: ["Al Wiqan", "Al Waqan", "Al Waqan Village", "Al Wagan", "Wiqan", "Waqan", "Wagan", "الوقن", "الوقان"],
    },
    {
      key: "al-araad",
      name: "Al Araad / Bu Kirayyah",
      nameAr: "العراد / بو كرية",
      lat: 23.83,
      lng: 55.53,
      radiusKm: 22,
      aliases: [
        "Al Araad",
        "Al Arad",
        "Al'Arad",
        "Al Araad Village",
        "Al Arad 2",
        "Al Arad 10",
        "Araad",
        "Arad",
        "Bu Kirayyah",
        "Bu Kirayyah Farms",
        "Bu Kirayah",
        "Bu Kirayya",
        "Bu Koreyyah",
        "Abu Krayyah",
        "Al Ageer",
        "Al Ager",
        "Al Ujayr",
        "Sayh Al Ujayr",
        "Sayh Al Saham",
        "Sayh Al Saham 1",
        "Sayh Al Saham 2",
        "Sayh Saham",
        "Sayh Al Laham",
        "Al Muntaha",
        "Al Muntaha 1",
        "Al Muntaha 2",
        "Daghr",
        "العراد",
        "العراد 2",
        "العراد 10",
        "بو كرية",
        "بو كريه",
        "بوكرية",
        "الأجير",
        "الاجير",
        "سيح السهم",
        "سيح اللحم",
        "المنتهى",
        "داغر",
      ],
    },
    {
      key: "al-qoua",
      name: "Al Qou'a",
      nameAr: "القوع",
      lat: 23.45,
      lng: 55.41,
      radiusKm: 24,
      aliases: ["Al Qou'a", "Al Qoua", "Al Qouaa", "Al Quaa", "Al Qua", "Qou'a", "Qoua", "Qouaa", "Quaa", "القوع"],
    },
    {
      key: "sweihan",
      name: "Sweihan",
      nameAr: "سويحان",
      lat: 24.46,
      lng: 55.33,
      radiusKm: 20,
      aliases: ["Sweihan", "Suweihan", "Swaihan", "Swaiehan", "Sweihan City", "سويحان"],
    },
  ];

  function getInitialLanguage() {
    const stored = window.localStorage.getItem(storageKey);
    if (supported.includes(stored)) return stored;

    const documentLang = document.documentElement.lang || "en";
    return documentLang.toLowerCase().startsWith("ar") ? "ar" : "en";
  }

  function applyLanguage(language) {
    const lang = supported.includes(language) ? language : "en";
    document.documentElement.lang = lang;
    document.documentElement.dir = "ltr";
    document.body.setAttribute("data-lily-lang", lang);
    document.body.classList.toggle("lily-is-arabic", lang === "ar");

    document.querySelectorAll("[data-i18n-en][data-i18n-ar]").forEach((node) => {
      node.textContent = node.getAttribute(`data-i18n-${lang}`) || "";
    });

    document.querySelectorAll("[data-i18n-html-en][data-i18n-html-ar]").forEach((node) => {
      node.innerHTML = node.getAttribute(`data-i18n-html-${lang}`) || "";
    });

    document.querySelectorAll("[data-i18n-placeholder-en][data-i18n-placeholder-ar]").forEach((node) => {
      node.setAttribute("placeholder", node.getAttribute(`data-i18n-placeholder-${lang}`) || "");
    });

    document.querySelectorAll("[data-lily-lang-button]").forEach((button) => {
      const isActive = button.getAttribute("data-lily-lang-button") === lang;
      button.setAttribute("aria-pressed", String(isActive));
    });

    window.scrollTo({ left: 0, top: window.scrollY });
    window.localStorage.setItem(storageKey, lang);
    document.dispatchEvent(new CustomEvent("lily:language-change"));
  }

  function currentLanguage() {
    return document.body.getAttribute("data-lily-lang") || getInitialLanguage();
  }

  function translate(en, ar) {
    return currentLanguage() === "ar" ? ar : en;
  }

  function parseCents(value) {
    const cents = Number.parseInt(value || "0", 10);
    return Number.isFinite(cents) ? cents : 0;
  }

  function formatAED(cents) {
    return `AED ${(parseCents(cents) / 100).toFixed(2)}`;
  }

  function formatAedAmount(cents) {
    const amount = parseCents(cents) / 100;
    return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
  }

  function setupLoadingScreen() {
    const loader = document.querySelector("[data-lily-loader]");
    if (!loader) return;

    const startedAt = window.performance ? window.performance.now() : Date.now();
    const minimumVisibleMs = 1200;
    let hidden = false;

    function hide() {
      if (hidden) return;
      hidden = true;
      loader.classList.add("is-hidden");
      window.setTimeout(() => loader.remove(), 650);
    }

    function hideAfterMinimum() {
      const now = window.performance ? window.performance.now() : Date.now();
      const remaining = Math.max(minimumVisibleMs - (now - startedAt), 0);
      window.setTimeout(hide, remaining);
    }

    if (document.readyState === "complete") {
      hideAfterMinimum();
    } else {
      window.addEventListener("load", hideAfterMinimum, { once: true });
    }

    window.setTimeout(hide, 3200);
  }

  function setupRootLandingFallback() {
    const normalizedPath = window.location.pathname.replace(/\/+$/, "") || "/";
    if (normalizedPath !== "/") return;

    const params = new URLSearchParams(window.location.search);
    const hasLanding = Boolean(document.querySelector(".lily-landing-page"));

    if (params.get("view") === "landing" && hasLanding && window.history?.replaceState) {
      window.history.replaceState(null, "", `${window.location.origin}/${window.location.hash || ""}`);
      return;
    }

    if (params.has("preview_theme_id") || params.get("view") === "landing" || hasLanding) return;

    const staleHome = document.querySelector('[data-lily-section="home"]');
    if (!staleHome) return;

    const landingUrl = new URL(window.location.href);
    landingUrl.searchParams.set("view", "landing");
    landingUrl.searchParams.set("landing_refresh", "1");
    window.location.replace(landingUrl.toString());
  }

  function setupLanguageSwitchers() {
    const menuToggle = document.getElementById("lily-menu-toggle");
    if (menuToggle) menuToggle.checked = false;

    document.querySelectorAll("[data-lily-lang-button]").forEach((button) => {
      button.addEventListener("click", () => {
        applyLanguage(button.getAttribute("data-lily-lang-button"));
      });
    });
  }

  function setupMenuInteractions() {
    const menuToggle = document.getElementById("lily-menu-toggle");
    const menu = document.querySelector(".lily-menu");
    const overlay = document.querySelector(".lily-menu-overlay");
    const openButton = document.querySelector("[data-lily-menu-open]");
    const closeButton = document.querySelector("[data-lily-menu-close]");
    if (!menuToggle || !menu) return;

    const syncMenuControls = () => {
      if (openButton) openButton.setAttribute("aria-expanded", menuToggle.checked ? "true" : "false");
    };

    const openMenu = () => {
      menuToggle.checked = true;
      syncMenuControls();
    };

    const closeMenu = () => {
      menuToggle.checked = false;
      syncMenuControls();
    };

    if (openButton) openButton.addEventListener("click", openMenu);
    if (closeButton) closeButton.addEventListener("click", closeMenu);
    menuToggle.addEventListener("change", syncMenuControls);
    syncMenuControls();

    if (overlay) {
      const closeFromOverlay = (event) => {
        event.preventDefault();
        closeMenu();
      };

      overlay.addEventListener("pointerdown", closeFromOverlay);
      overlay.addEventListener("touchstart", closeFromOverlay, { passive: false });
      overlay.addEventListener("click", closeFromOverlay);
    }

    const closeFromOutsidePoint = (event) => {
      if (!menuToggle.checked) return;
      if (!(event.target instanceof Element)) return;
      if (
        menu.contains(event.target) ||
        event.target.closest("[data-lily-menu-open], [data-lily-menu-close], .lily-menu-toggle, .lily-header__menu-button")
      ) {
        return;
      }

      const touch = event.touches && event.touches[0];
      const clientX = typeof event.clientX === "number" ? event.clientX : touch ? touch.clientX : null;
      if (clientX === null) return;

      if (clientX > menu.getBoundingClientRect().right - 1) {
        event.preventDefault();
        closeMenu();
      }
    };

    document.addEventListener("pointerdown", closeFromOutsidePoint, true);
    document.addEventListener("touchstart", closeFromOutsidePoint, { capture: true, passive: false });
    document.addEventListener("click", closeFromOutsidePoint, true);

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeMenu();
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let trackingSwipe = false;

    menu.addEventListener(
      "touchstart",
      (event) => {
        const touch = event.touches[0];
        if (!touch || !menuToggle.checked) return;

        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        trackingSwipe = true;
      },
      { passive: true }
    );

    menu.addEventListener(
      "touchmove",
      (event) => {
        if (!trackingSwipe || !menuToggle.checked) return;

        const touch = event.touches[0];
        if (!touch) return;

        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (deltaX < -52 && Math.abs(deltaX) > Math.abs(deltaY) * 1.35) {
          trackingSwipe = false;
          closeMenu();
        }
      },
      { passive: true }
    );

    menu.addEventListener(
      "touchend",
      () => {
        trackingSwipe = false;
      },
      { passive: true }
    );
  }

  function normalizeCartLinks() {
    document.querySelectorAll("a[href*='/cart?view=map'], a[href*=\"/cart?view=map\"]").forEach((link) => {
      const href = link.getAttribute("href") || "";
      link.setAttribute("href", href.replace(/\/cart\?view=map/g, "/cart"));
    });

    document.querySelectorAll("input[name='return_to']").forEach((input) => {
      if (!input.value.includes("/cart?view=map")) return;
      input.value = input.value.replace(/\/cart\?view=map/g, "/cart");
    });
  }

  function setupFaviconFallback() {
    const script = Array.from(document.scripts).find((node) => (node.src || "").includes("/assets/lily-dulce.js"));
    const faviconUrl = script ? script.src.replace(/\/assets\/lily-dulce\.js(\?.*)?$/, "/assets/mesh-story-favicon-transparent.png$1") : "";

    if (!faviconUrl) return;

    document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']").forEach((link) => {
      link.remove();
    });

    [
      { rel: "icon", type: "image/png" },
      { rel: "shortcut icon", type: "image/png" },
      { rel: "apple-touch-icon" },
    ].forEach((attrs) => {
      const link = document.createElement("link");
      link.rel = attrs.rel;
      link.href = faviconUrl;
      if (attrs.type) link.type = attrs.type;
      document.head.appendChild(link);
    });
  }

  function setupStockTopbarCompatibility() {
    document.querySelectorAll("[data-lily-section='home']").forEach((section) => {
      if (section.querySelector(":scope > .lily-stock-topbar")) return;

      const legacyBanner = section.querySelector(".lily-stock-banner");
      if (!legacyBanner) return;

      legacyBanner.classList.remove("lily-stock-banner");
      legacyBanner.classList.add("lily-stock-topbar");

      if (!legacyBanner.querySelector(".lily-stock-topbar__inner")) {
        const inner = document.createElement("div");
        inner.className = "lily-stock-topbar__inner";
        while (legacyBanner.firstChild) inner.appendChild(legacyBanner.firstChild);
        legacyBanner.appendChild(inner);
      }

      section.insertBefore(legacyBanner, section.firstChild);
    });
  }

  function setupCategoryFilters() {
    document.querySelectorAll("[data-lily-section='home']").forEach((section) => {
      let buttons = Array.from(section.querySelectorAll("[data-lily-filter]"));
      const grid = section.querySelector("[data-lily-product-grid]");
      let cards = Array.from(section.querySelectorAll("[data-lily-product-card]"));
      const cardOriginalIndex = new Map(cards.map((card, index) => [card, index]));

      cards.sort((a, b) => {
        const aAvailable = a.getAttribute("data-lily-available") === "true";
        const bAvailable = b.getAttribute("data-lily-available") === "true";
        if (aAvailable !== bAvailable) return aAvailable ? -1 : 1;

        const aOrder = Number.parseInt(a.getAttribute("data-lily-sort-order") || "900", 10);
        const bOrder = Number.parseInt(b.getAttribute("data-lily-sort-order") || "900", 10);
        if (aOrder !== bOrder) return aOrder - bOrder;
        return (cardOriginalIndex.get(a) || 0) - (cardOriginalIndex.get(b) || 0);
      });

      if (grid) {
        cards.forEach((card) => grid.appendChild(card));
      }

      buttons
        .filter((button) => button.getAttribute("data-lily-filter") === "sold-out")
        .forEach((button) => button.remove());

      buttons = buttons.filter((button) => button.isConnected);

      function matchesFilter(card, filter) {
        if (filter === "all") return true;
        const categories = (card.getAttribute("data-lily-categories") || "").split(/\s+/);
        return categories.includes(filter);
      }

      function countForFilter(filter) {
        return cards.filter((card) => matchesFilter(card, filter)).length;
      }

      function updateCounts() {
        buttons.forEach((button) => {
          const filter = button.getAttribute("data-lily-filter");
          const count = countForFilter(filter);
          const countNode = button.querySelector("[data-lily-count]");
          if (countNode) countNode.textContent = String(count);
        });
      }

      function removeEmptyDynamicCategories() {
        buttons = buttons.filter((button) => {
          const filter = button.getAttribute("data-lily-filter");
          const shouldRemove =
            filter !== "all" &&
            button.hasAttribute("data-lily-dynamic-category") &&
            countForFilter(filter) === 0;

          if (shouldRemove) {
            button.remove();
            return false;
          }

          return true;
        });
      }

      function applyFilter(filter) {
        buttons.forEach((button) => {
          button.classList.toggle("is-active", button.getAttribute("data-lily-filter") === filter);
        });

        cards.forEach((card) => {
          card.hidden = !matchesFilter(card, filter);
        });
      }

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          applyFilter(button.getAttribute("data-lily-filter") || "all");
        });
      });

      removeEmptyDynamicCategories();
      updateCounts();
      applyFilter("all");
    });
  }

  function setupProductGalleries() {
    document.querySelectorAll("[data-lily-product-gallery]").forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll("[data-lily-product-slide]"));
      const triggers = Array.from(gallery.querySelectorAll("[data-lily-product-slide-trigger]"));
      const previous = gallery.querySelector("[data-lily-gallery-prev]");
      const next = gallery.querySelector("[data-lily-gallery-next]");
      if (!slides.length) return;

      let activeIndex = Math.max(
        0,
        slides.findIndex((slide) => slide.classList.contains("is-active"))
      );

      function showSlide(index) {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.hidden = !isActive;
          slide.classList.toggle("is-active", isActive);
        });
        triggers.forEach((trigger, triggerIndex) => {
          const isActive = triggerIndex === activeIndex;
          trigger.classList.toggle("is-active", isActive);
          trigger.setAttribute("aria-pressed", String(isActive));
        });
      }

      previous?.addEventListener("click", () => showSlide(activeIndex - 1));
      next?.addEventListener("click", () => showSlide(activeIndex + 1));
      triggers.forEach((trigger, triggerIndex) => {
        trigger.addEventListener("click", () => showSlide(triggerIndex));
      });

      showSlide(activeIndex);
    });
  }

  function setupChoiceGroups() {
    document.querySelectorAll("[data-lily-choice-group], [data-lily-seed-options]").forEach((group) => {
      const choices = Array.from(group.querySelectorAll("[data-lily-choice], [data-lily-seed-choice]"));
      const output = group.querySelector("[data-lily-choice-output], [data-lily-seed-output]");
      const error = group.querySelector("[data-lily-choice-error], [data-lily-seed-error]");
      const form = group.closest("form");
      if (!choices.length || !output || !form) return;
      const required = group.getAttribute("data-lily-choice-required") !== "false";

      function selectedValue() {
        return choices
          .filter((choice) => choice.checked)
          .map((choice) => choice.value)
          .join(", ");
      }

      function updateState() {
        output.value = selectedValue();
        const hasSelection = output.value.length > 0;
        const isValid = hasSelection || !required;
        group.classList.toggle("has-error", !isValid && group.hasAttribute("data-lily-touched"));
        if (error) error.hidden = isValid || !group.hasAttribute("data-lily-touched");
        return isValid;
      }

      choices.forEach((choice) => {
        choice.addEventListener("change", () => {
          group.setAttribute("data-lily-touched", "true");
          updateState();
        });
      });

      form.addEventListener("submit", (event) => {
        group.setAttribute("data-lily-touched", "true");
        if (updateState()) return;

        event.preventDefault();
        const message = translate(
          group.getAttribute("data-lily-choice-error-en") ||
            group.getAttribute("data-lily-seed-error-en") ||
            "Please choose at least one option.",
          group.getAttribute("data-lily-choice-error-ar") ||
            group.getAttribute("data-lily-seed-error-ar") ||
            "يرجى اختيار خيار واحد على الأقل."
        );
        if (error) {
          error.textContent = message;
          error.hidden = false;
        }
        choices[0].focus();
      });

      updateState();
    });
  }

  function syncVariantCapacityMetadata(form, source) {
    if (!form || !source) return;

    const group = source.getAttribute("data-lily-variant-capacity-group") || "";
    const units = source.getAttribute("data-lily-variant-capacity-units") || "1";
    const groupInput = form.querySelector("[data-lily-capacity-group-property]");
    const unitsInput = form.querySelector("[data-lily-capacity-units-property]");

    if (group) {
      form.setAttribute("data-lily-inventory-group", group);
      form.setAttribute("data-lily-inventory-units", units);
      if (groupInput) groupInput.value = group;
      if (unitsInput) unitsInput.value = units;
    }
  }

  function setupVariantChoices() {
    document.querySelectorAll("[data-lily-variant-choice-group]").forEach((group) => {
      const form = group.closest(".lily-product-form");
      const productPage = form ? form.closest(".lily-product-page") : null;
      const priceNode = productPage ? productPage.querySelector("[data-lily-product-price]") : null;
      const quantityInput = form ? form.querySelector("[data-lily-product-quantity]") : null;
      const submitButton = form ? form.querySelector("button[type='submit']") : null;
      const choices = Array.from(group.querySelectorAll("[data-lily-variant-choice]"));
      if (!form || !choices.length) return;

      function activeChoice() {
        return choices.find((choice) => choice.checked && !choice.disabled) || choices.find((choice) => !choice.disabled);
      }

      function syncVariantChoice() {
        const choice = activeChoice();
        if (!choice) return;

        if (!choice.checked) choice.checked = true;

        const priceEn = choice.getAttribute("data-lily-variant-price-en") || "";
        const priceAr = choice.getAttribute("data-lily-variant-price-ar") || priceEn;
        if (priceNode) {
          priceNode.setAttribute("data-lily-base-price", choice.getAttribute("data-lily-variant-price") || "0");
          priceNode.setAttribute("data-i18n-en", priceEn);
          priceNode.setAttribute("data-i18n-ar", priceAr);
          priceNode.textContent = translate(priceEn, priceAr);
        }

        const inventoryLimit = choice.getAttribute("data-lily-variant-inventory") || "";
        if (quantityInput) quantityInput.setAttribute("data-lily-inventory-limit", inventoryLimit);
        form.setAttribute("data-lily-inventory-limit", inventoryLimit);
        syncVariantCapacityMetadata(form, choice);
        if (submitButton) submitButton.disabled = choice.disabled;
      }

      choices.forEach((choice) => {
        choice.addEventListener("change", syncVariantChoice);
      });

      document.addEventListener("lily:language-change", syncVariantChoice);
      syncVariantChoice();
    });
  }

  function setupInventoryGuards() {
    const messages = {
      swiss_roll: {
        en: (remaining) =>
          remaining > 0
            ? `Only ${remaining} Swiss roll boxes remain for this fulfillment date.`
            : "Swiss roll capacity is fully booked for this date.",
        ar: (remaining) =>
          remaining > 0
            ? `المتبقي ${remaining} فقط من سويسرول لهذا التاريخ.`
            : "تم حجز طاقة السويسرول بالكامل لهذا التاريخ.",
      },
      cookies: {
        en: (remaining) =>
          remaining > 0
            ? `Only ${remaining} cookie boxes remain for this fulfillment date.`
            : "Cookie capacity is fully booked for this date.",
        ar: (remaining) =>
          remaining > 0
            ? `المتبقي ${remaining} فقط من علب الكوكيز لهذا التاريخ.`
            : "تم حجز طاقة الكوكيز بالكامل لهذا التاريخ.",
      },
      biscuit: {
        en: (remaining) =>
          remaining > 0
            ? `Only ${remaining} biscuit items remain for this fulfillment date.`
            : "Biscuit capacity is fully booked for this date.",
        ar: (remaining) =>
          remaining > 0
            ? `المتبقي ${remaining} فقط من البسكوت لهذا التاريخ.`
            : "تم حجز طاقة البسكوت بالكامل لهذا التاريخ.",
      },
      slice_cake: {
        en: (remaining) =>
          remaining > 0
            ? `Only ${remaining} mini cake items remain for this fulfillment date.`
            : "Mini cake capacity is fully booked for this date.",
        ar: (remaining) =>
          remaining > 0
            ? `المتبقي ${remaining} فقط من الميني كيك لهذا التاريخ.`
            : "تم حجز طاقة الميني كيك بالكامل لهذا التاريخ.",
      },
      donuts: {
        en: (remaining) =>
          remaining > 0
            ? `Only ${remaining} donut boxes remain for this fulfillment date.`
            : "Donut capacity is fully booked for this date.",
        ar: (remaining) =>
          remaining > 0
            ? `المتبقي ${remaining} فقط من علب الدونات لهذا التاريخ.`
            : "تم حجز طاقة الدونات بالكامل لهذا التاريخ.",
      },
    };

    const capacityConnectionMessage = {
      en: "We could not confirm order-date capacity right now. Please refresh or try again before checkout.",
      ar: "تعذر تأكيد طاقة تاريخ الطلب حالياً. يرجى تحديث الصفحة أو المحاولة مرة أخرى قبل الدفع.",
    };
    const capacityHoldMessage = {
      en: "Reserving your order date for checkout...",
      ar: "جاري حجز تاريخ الطلب للدفع...",
    };
    const capacityHoldConnectionMessage = {
      en: "We could not reserve this order date for checkout. Please refresh or try again.",
      ar: "تعذر حجز تاريخ الطلب للدفع. يرجى تحديث الصفحة أو المحاولة مرة أخرى.",
    };
    const missingDeliveryDateMessage = {
      en: "Please choose your order date before checkout.",
      ar: "يرجى اختيار تاريخ الطلب قبل الدفع.",
    };
    const capacityApiBase = "https://mesh-story-bice.vercel.app/apps/lily-capacity";

    const cartQuantityInputs = Array.from(document.querySelectorAll("[data-lily-cart-quantity]"));
    const guard = document.querySelector("[data-lily-inventory-guard]");
    const checkoutButton = document.querySelector(".lily-checkout-button");
    const checkoutForm = document.querySelector("[data-lily-cart-update-form]");
    const dateInput = document.querySelector("[data-lily-delivery-date]");

    let availabilityDate = "";
    let availabilityPromise = null;
    let updateId = 0;
    let submitAfterCapacityCheck = false;

    function messageFor(group, remaining) {
      const groupMessages = messages[group];
      const fallbackMessages = {
        en: (value) =>
          Number.parseFloat(value) > 0
            ? `Only ${value} ${capacityGroupLabel(group)} remain for this fulfillment date.`
            : `${capacityGroupLabel(group)} capacity is fully booked for this date.`,
        ar: (value) =>
          Number.parseFloat(value) > 0
            ? `المتبقي ${value} فقط من ${capacityGroupLabel(group)} لهذا التاريخ.`
            : `تم حجز طاقة ${capacityGroupLabel(group)} بالكامل لهذا التاريخ.`,
      };
      const activeMessages = groupMessages || fallbackMessages;
      const displayRemaining =
        isHalfStepCapacityGroup(group)
          ? Number.isInteger(remaining / 2)
            ? String(remaining / 2)
            : (remaining / 2).toFixed(1)
          : String(remaining);
      return translate(
        activeMessages.en(displayRemaining),
        activeMessages.ar(displayRemaining)
      );
    }

    function capacityConnectionError() {
      return translate(capacityConnectionMessage.en, capacityConnectionMessage.ar);
    }

    function availabilityEndpoint(dateValue) {
      const configuredEndpoint =
        window.LILY_CAPACITY_AVAILABILITY_URL || `${capacityApiBase}/availability`;
      const separator = configuredEndpoint.includes("?") ? "&" : "?";
      return `${configuredEndpoint}${separator}date=${encodeURIComponent(dateValue)}`;
    }

    function holdEndpoint() {
      return window.LILY_CAPACITY_HOLD_URL || `${capacityApiBase}/holds`;
    }

    function normalizeAvailability(payload) {
      const normalizedScheduling = normalizeDeliveryScheduling(payload?.scheduling);
      if (normalizedScheduling) {
        Object.assign(deliveryScheduling, normalizedScheduling);
        syncDeliverySchedulingCopy();
        document.dispatchEvent(new CustomEvent("lily:delivery-scheduling-change"));
      }

      const byGroup = {};
      const groups = Array.isArray(payload?.groups) ? payload.groups : [];

      groups.forEach((entry) => {
        const group = normalizeCapacityGroupKey(entry?.group);
        if (!group || !capacityGroupKeys.includes(group)) return;

        const remaining = Number.parseInt(entry.remaining, 10);
        const limit = Number.parseInt(entry.limit, 10);
        const used = Number.parseInt(entry.used, 10);

        byGroup[group] = {
          remaining: Number.isFinite(remaining) ? Math.max(0, remaining) : 0,
          limit: Number.isFinite(limit) ? Math.max(0, limit) : 0,
          used: Number.isFinite(used) ? Math.max(0, used) : 0,
          closed: entry.closed === true,
        };
      });

      return byGroup;
    }

    async function fetchAvailability(dateValue) {
      if (!dateValue) return {};

      if (!availabilityPromise || availabilityDate !== dateValue) {
        availabilityDate = dateValue;
        availabilityPromise = fetch(availabilityEndpoint(dateValue), {
          headers: { Accept: "application/json" },
          cache: "no-store",
        })
          .then((response) => {
            if (!response.ok) throw new Error("Capacity unavailable");
            return response.json();
          })
          .then(normalizeAvailability)
          .catch((error) => {
            if (availabilityDate === dateValue) availabilityPromise = null;
            throw error;
          });
      }

      return availabilityPromise;
    }

    function totalsByGroup() {
      return cartQuantityInputs.reduce((totals, input) => {
        const group = normalizeCapacityGroupKey(input.getAttribute("data-lily-inventory-group"));
        if (!group || !capacityGroupKeys.includes(group)) return totals;

        const quantity = Math.max(0, Number.parseInt(normalizeDigits(input.value), 10) || 0);
        const units = Math.max(
          1,
          Number.parseInt(input.getAttribute("data-lily-inventory-units") || "1", 10) || 1
        );
        totals[group] = (totals[group] || 0) + quantity * units;
        return totals;
      }, capacityGroupKeys.reduce((totals, group) => {
        totals[group] = 0;
        return totals;
      }, {}));
    }

    function hasCapacityItems() {
      const totals = totalsByGroup();
      return Object.keys(totals).some((group) => (totals[group] || 0) > 0);
    }

    async function cartSnapshot() {
      try {
        const response = await fetch("/cart.js", {
          headers: { Accept: "application/json" },
          cache: "no-store",
        });
        if (!response.ok) return null;
        return response.json();
      } catch (_error) {
        return null;
      }
    }

    function applyHoldAttributes(attributes) {
      if (!checkoutForm || !attributes) return;
      const legacyHoldAttributeKeys = [
        "_lily_capacity_hold_id",
        "_lily_capacity_hold_date",
        "_lily_capacity_hold_created_date",
        "_lily_capacity_hold_expires_at",
        "_lily_capacity_hold_groups",
        "_lily_capacity_hold_signature",
      ];

      checkoutForm.querySelectorAll("[data-lily-capacity-hold-input]").forEach((input) => {
        input.remove();
      });

      legacyHoldAttributeKeys.forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `attributes[${key}]`;
        input.value = "";
        input.setAttribute("data-lily-capacity-hold-input", "true");
        checkoutForm.appendChild(input);
      });

      Object.keys(attributes).forEach((key) => {
        const value = attributes[key];
        if (value === undefined || value === null || value === "") return;

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `attributes[${key}]`;
        input.value = String(value);
        input.setAttribute("data-lily-capacity-hold-input", "true");
        checkoutForm.appendChild(input);
      });
    }

    async function createCheckoutHold(dateValue) {
      if (!hasCapacityItems()) return true;

      if (guard) {
        guard.hidden = false;
        guard.textContent = translate(capacityHoldMessage.en, capacityHoldMessage.ar);
      }
      if (checkoutButton) checkoutButton.disabled = true;

      const cart = await cartSnapshot();
      const response = await fetch(holdEndpoint(), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        cache: "no-store",
        body: JSON.stringify({
          deliveryDate: dateValue,
          totals: totalsByGroup(),
          cartToken: cart?.token || "",
          cart,
        }),
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        if (payload && payload.group && Number.isFinite(Number(payload.remaining))) {
          guard.textContent = messageFor(payload.group, Number(payload.remaining));
        } else if (payload && typeof payload.error === "string" && payload.error) {
          guard.textContent = payload.error;
        } else {
          guard.textContent = translate(
            capacityHoldConnectionMessage.en,
            capacityHoldConnectionMessage.ar
          );
        }
        if (checkoutButton) checkoutButton.disabled = true;
        return false;
      }

      applyHoldAttributes(payload.attributes || {});
      return true;
    }

    function currentViolations(availability) {
      const totals = totalsByGroup();
      return Object.keys(totals)
        .filter((group) => capacityGroupKeys.includes(group))
        .filter((group) => {
          const groupAvailability = availability[group];
          if (!groupAvailability) return true;
          if (groupAvailability.closed) return true;
          return (totals[group] || 0) > groupAvailability.remaining;
        });
    }

    async function updateGuard() {
      if (!cartQuantityInputs.length || !guard) return true;
      if (isStorefrontClosed()) {
        guard.hidden = false;
        guard.textContent = storefrontClosedMessage();
        if (checkoutButton) checkoutButton.disabled = true;
        return false;
      }

      const dateValue = dateInput ? dateInput.value : "";
      const requestId = ++updateId;

      if (!dateValue) {
        guard.hidden = false;
        guard.textContent = translate(
          missingDeliveryDateMessage.en,
          missingDeliveryDateMessage.ar
        );
        if (checkoutButton) checkoutButton.disabled = true;
        return false;
      }

      let availability = {};
      if (checkoutButton) checkoutButton.disabled = true;

      try {
        availability = await fetchAvailability(dateValue);
      } catch (_error) {
        if (requestId !== updateId) return false;

        guard.hidden = false;
        guard.textContent = capacityConnectionError();
        if (checkoutButton) checkoutButton.disabled = true;
        return false;
      }

      if (requestId !== updateId) return true;

      const violations = currentViolations(availability);
      const hasViolation = violations.length > 0;
      guard.hidden = !hasViolation;
      if (checkoutButton) checkoutButton.disabled = hasViolation;

      if (hasViolation) {
        guard.textContent = violations
          .map((group) => messageFor(group, availability[group]?.remaining || 0))
          .join(" ");
      } else {
        guard.textContent = translate(
          guard.getAttribute("data-i18n-en") || "",
          guard.getAttribute("data-i18n-ar") || ""
        );
      }

      return !hasViolation;
    }

    cartQuantityInputs.forEach((input) => {
      const group = normalizeCapacityGroupKey(input.getAttribute("data-lily-inventory-group"));
      if (!group || !capacityGroupKeys.includes(group)) return;
      input.addEventListener("input", updateGuard);
      input.addEventListener("change", updateGuard);
    });

    if (dateInput) {
      dateInput.addEventListener("input", updateGuard);
      dateInput.addEventListener("change", updateGuard);
      dateInput.addEventListener("blur", updateGuard);
    }

    if (checkoutForm) {
      checkoutForm.addEventListener("submit", (event) => {
        if (submitAfterCapacityCheck) {
          submitAfterCapacityCheck = false;
          return;
        }

        const submitter = event.submitter;
        if (submitter && submitter.getAttribute("name") !== "checkout") return;

        if (isStorefrontClosed()) {
          event.preventDefault();
          if (guard) {
            guard.hidden = false;
            guard.textContent = storefrontClosedMessage();
            guard.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            showStorefrontClosedMessage(checkoutButton);
          }
          if (checkoutButton) checkoutButton.disabled = true;
          return;
        }

        const dateValue = dateInput ? dateInput.value : "";
        event.preventDefault();

        if (!dateValue) {
          if (guard) {
            guard.hidden = false;
            guard.textContent = translate(
              missingDeliveryDateMessage.en,
              missingDeliveryDateMessage.ar
            );
            guard.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          if (checkoutButton) checkoutButton.disabled = true;
          return;
        }

        updateGuard().then(async (isAllowed) => {
          if (!isAllowed) {
            guard.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
          }

          const holdCreated = await createCheckoutHold(dateValue).catch(() => false);
          if (!holdCreated) {
            guard.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
          }

          submitAfterCapacityCheck = true;
          if (checkoutButton) checkoutButton.disabled = false;
          if (typeof checkoutForm.requestSubmit === "function" && checkoutButton) {
            checkoutForm.requestSubmit(checkoutButton);
            return;
          }

          const checkoutMarker = document.createElement("input");
          checkoutMarker.type = "hidden";
          checkoutMarker.name = "checkout";
          checkoutMarker.value = "checkout";
          checkoutForm.appendChild(checkoutMarker);
          checkoutForm.submit();
        });
      });
    }

    document.addEventListener("lily:language-change", updateGuard);
    document.addEventListener("lily:delivery-scheduling-change", updateGuard);
    document.addEventListener("lily:storefront-status-change", updateGuard);
    loadDeliveryScheduling().then(updateGuard);
    updateGuard();
  }

  function setupAddOnPricing() {
    document.querySelectorAll(".lily-product-form").forEach((form) => {
      const addOnChoices = Array.from(form.querySelectorAll("[data-lily-addon-variant-id]"));
      if (!addOnChoices.length) return;

      const productPage = form.closest(".lily-product-page");
      const priceNode = productPage ? productPage.querySelector("[data-lily-product-price]") : null;
      const quantityInput = form.querySelector("[name='quantity']");
      const basePrice = parseCents(priceNode ? priceNode.getAttribute("data-lily-base-price") : "0");

      function selectedAddOns() {
        return addOnChoices.filter((choice) => choice.checked && choice.getAttribute("data-lily-addon-variant-id"));
      }

      function selectedAddOnTotal() {
        return selectedAddOns().reduce((total, choice) => {
          return total + parseCents(choice.getAttribute("data-lily-addon-price"));
        }, 0);
      }

      function updateDisplayedPrice() {
        if (!priceNode) return;
        priceNode.textContent = formatAED(basePrice + selectedAddOnTotal());
      }

      addOnChoices.forEach((choice) => {
        choice.addEventListener("change", updateDisplayedPrice);
      });

      form.addEventListener("submit", async (event) => {
        if (event.defaultPrevented) return;

        const chosenAddOns = selectedAddOns();
        if (!chosenAddOns.length) return;

        event.preventDefault();

        const submitButton = form.querySelector("button[type='submit']");
        const originalButtonText = submitButton ? submitButton.textContent : "";
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = translate("Adding...", "جارٍ الإضافة...");
        }

        const formData = new FormData(form);
        const quantity = Math.max(1, Number.parseInt(normalizeDigits(quantityInput ? quantityInput.value : "1"), 10) || 1);
        const productProperties = {};

        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value) {
            productProperties[match[1]] = String(value);
          }
        });

        const mainItem = {
          id: Number(formData.get("id")),
          quantity,
        };

        if (Object.keys(productProperties).length) {
          mainItem.properties = productProperties;
        }

        const items = [mainItem].concat(
          chosenAddOns.map((choice) => ({
            id: Number(choice.getAttribute("data-lily-addon-variant-id")),
            quantity,
            properties: {
              _lily_addon_for: form.getAttribute("data-lily-product-title") || "",
              _lily_addon_parent: form.getAttribute("data-lily-product-handle") || "",
              _lily_addon_name:
                currentLanguage() === "ar"
                  ? choice.getAttribute("data-lily-addon-title-ar") || ""
                  : choice.getAttribute("data-lily-addon-title-en") || "",
            },
          }))
        );

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) throw new Error("Could not add product add-ons.");
          window.location.href = "/cart";
        } catch (error) {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }
          window.alert(translate("Could not add the selected add-ons. Please try again.", "تعذرت إضافة الإضافات المختارة. يرجى المحاولة مرة أخرى."));
        }
      });

      updateDisplayedPrice();
    });
  }

  function setupWholeWheatVariantPicker() {
    document.querySelectorAll("[data-lily-whole-wheat-variant-select]").forEach((select) => {
      const form = select.closest(".lily-product-form");
      const productPage = form ? form.closest(".lily-product-page") : null;
      const priceNode = productPage ? productPage.querySelector("[data-lily-product-price]") : null;
      const quantityInput = form ? form.querySelector("[data-lily-product-quantity]") : null;
      const submitButton = form ? form.querySelector("button[type='submit']") : null;
      const addOnOrder = ["Olives", "Cheddar", "Chocolate", "Jalapeño"];
      const addOnChoices = form ? Array.from(form.querySelectorAll("[data-lily-whole-wheat-addon]")) : [];
      if (!form || !addOnChoices.length) return;

      const optionByTitle = new Map(
        Array.from(select.options).map((option) => [option.getAttribute("data-lily-variant-title") || option.textContent.trim(), option])
      );

      function selectedVariantTitle() {
        const selected = addOnOrder.filter((addOn) => {
          return addOnChoices.some((choice) => choice.checked && choice.getAttribute("data-lily-whole-wheat-addon") === addOn);
        });

        return selected.length ? selected.join(" + ") : "Plain";
      }

      function syncVariant() {
        const matchingOption = optionByTitle.get(selectedVariantTitle());
        if (!matchingOption) return;

        select.value = matchingOption.value;
        if (priceNode) priceNode.textContent = formatAED(matchingOption.getAttribute("data-lily-variant-price"));

        const inventoryLimit = matchingOption.getAttribute("data-lily-variant-inventory") || "";
        if (inventoryLimit && quantityInput) {
          quantityInput.setAttribute("data-lily-inventory-limit", inventoryLimit);
          form.setAttribute("data-lily-inventory-limit", inventoryLimit);
        }
        syncVariantCapacityMetadata(form, matchingOption);

        if (submitButton) submitButton.disabled = matchingOption.disabled;
      }

      addOnChoices.forEach((choice) => {
        choice.addEventListener("change", syncVariant);
      });

      syncVariant();
    });
  }

  function setupFallbackPages() {
    const fallbackContainers = document.querySelectorAll("[data-lily-fallback-pages]");
    if (!fallbackContainers.length) return;

    const path = window.location.pathname;
    let handle = "not-found";

    if (path.includes("/pages/home")) {
      handle = "home";
    } else if (path.includes("/pages/faq")) {
      handle = "faq";
    } else if (path.includes("/pages/policy-refund-and-delivery")) {
      handle = "policy-refund-and-delivery";
    } else if (path.includes("/pages/about-contact-us")) {
      handle = "about-contact-us";
    } else if (path.includes("/pages/delivery")) {
      handle = "delivery";
    } else if (path.includes("/pages/pickup")) {
      handle = "pickup";
    } else if (path.includes("/pages/wholesale")) {
      handle = "wholesale";
    } else if (path.includes("/collections/bread")) {
      handle = "bread";
    }

    const fallbackTitles = {
      home: "Mesh Story",
      faq: "FAQ",
      "policy-refund-and-delivery": "Policy, Refund And Delivery",
      "about-contact-us": "About & Contact",
      delivery: "Delivery",
      pickup: "Pickup",
      wholesale: "Wholesale",
      bread: "Bread",
      "not-found": "Page Not Found",
    };

    document.title = fallbackTitles[handle] || fallbackTitles["not-found"];

    fallbackContainers.forEach((container) => {
      container.querySelectorAll("[data-lily-fallback-page]").forEach((page) => {
        page.hidden = page.getAttribute("data-lily-fallback-page") !== handle;
      });
    });
  }

  function normalizeDigits(value) {
    const arabicDigits = "٠١٢٣٤٥٦٧٨٩";
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";

    return String(value || "")
      .replace(/[٠-٩]/g, (digit) => String(arabicDigits.indexOf(digit)))
      .replace(/[۰-۹]/g, (digit) => String(persianDigits.indexOf(digit)));
  }

  function normalizeDeliveryText(value) {
    return normalizeDigits(value)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[\u064B-\u065F\u0670]/g, "")
      .replace(/[أإآٱ]/g, "ا")
      .replace(/ى/g, "ي")
      .replace(/ة/g, "ه")
      .replace(/ؤ/g, "و")
      .replace(/ئ/g, "ي")
      .replace(/[^a-z0-9\u0600-\u06ff]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizedTextContains(haystack, needle) {
    if (!haystack || !needle) return false;
    return haystack === needle || haystack.includes(` ${needle} `) || haystack.startsWith(`${needle} `) || haystack.endsWith(` ${needle}`);
  }

  function findBlockedDeliveryText(...values) {
    const normalized = normalizeDeliveryText(values.filter(Boolean).join(" "));
    if (!normalized) return null;

    return (
      blockedDeliveryAreas.find((area) => {
        return area.aliases.some((alias) => normalizedTextContains(normalized, normalizeDeliveryText(alias)));
      }) || null
    );
  }

  function parseMapsCoordinates(value) {
    const text = normalizeDigits(value || "");
    const patterns = [
      /[?&]q=(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)/,
      /@(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)/,
      /(-?\d{1,2}\.\d+)\s*,\s*(-?\d{1,3}\.\d+)/,
    ];

    for (const pattern of patterns) {
      const match = text.match(pattern);
      if (!match) continue;

      const lat = Number.parseFloat(match[1]);
      const lng = Number.parseFloat(match[2]);
      if (Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180) {
        return { lat, lng };
      }
    }

    return null;
  }

  function findBlockedDeliveryCoordinates(lat, lng) {
    const numericLat = Number.parseFloat(lat);
    const numericLng = Number.parseFloat(lng);
    if (!Number.isFinite(numericLat) || !Number.isFinite(numericLng)) return null;

    return (
      blockedDeliveryAreas.find((area) => {
        return distanceKmBetween({ lat: numericLat, lng: numericLng }, area) <= area.radiusKm;
      }) || null
    );
  }

  function deliveryLocationFields(form) {
    const root = form?.closest(".lily-cart-page") || document;
    return {
      searchInput: root.querySelector("[data-lily-location-search]"),
      mapLinkInput: root.querySelector("[data-lily-map-link]"),
      latitudeInput: root.querySelector("[data-lily-lat]"),
      longitudeInput: root.querySelector("[data-lily-lng]"),
      statusNode: root.querySelector("[data-lily-location-status]"),
    };
  }

  function blockedDeliveryMessage(area) {
    return {
      en: `Delivery is not available to ${area.name}. Please choose another delivery address.`,
      ar: `التوصيل غير متاح إلى ${area.nameAr}. يرجى اختيار عنوان توصيل آخر.`,
    };
  }

  function setDeliveryLocationBlock(form, area) {
    const { searchInput, mapLinkInput, statusNode } = deliveryLocationFields(form);
    const message = blockedDeliveryMessage(area);
    if (form) form.dataset.lilyBlockedDeliveryArea = area.key;
    if (searchInput) searchInput.setCustomValidity(translate(message.en, message.ar));
    if (mapLinkInput) mapLinkInput.setCustomValidity(translate(message.en, message.ar));
    setMapStatus(statusNode, message.en, message.ar, "error");
  }

  function clearDeliveryLocationBlock(form) {
    const { searchInput, mapLinkInput, statusNode } = deliveryLocationFields(form);
    const hadBlock = Boolean(form?.dataset.lilyBlockedDeliveryArea);
    if (form) delete form.dataset.lilyBlockedDeliveryArea;
    if (searchInput) searchInput.setCustomValidity("");
    if (mapLinkInput) mapLinkInput.setCustomValidity("");
    if (hadBlock) {
      setMapStatus(
        statusNode,
        "Search, click the map, or use your location to save a UAE delivery pin.",
        "ابحثي أو اضغطي على الخريطة أو استخدمي موقعك لحفظ موقع توصيل داخل الإمارات."
      );
    } else if (statusNode) {
      statusNode.classList.remove("is-error");
    }
  }

  function findBlockedDeliveryAreaFromForm(form) {
    const existingKey = form?.dataset.lilyBlockedDeliveryArea;
    const existingArea = existingKey ? blockedDeliveryAreas.find((area) => area.key === existingKey) : null;
    if (existingArea) return existingArea;

    const { searchInput, mapLinkInput, latitudeInput, longitudeInput } = deliveryLocationFields(form);
    const textMatch = findBlockedDeliveryText(searchInput?.value, mapLinkInput?.value);
    if (textMatch) return textMatch;

    const linkCoordinates = parseMapsCoordinates(mapLinkInput?.value);
    if (linkCoordinates) {
      const linkMatch = findBlockedDeliveryCoordinates(linkCoordinates.lat, linkCoordinates.lng);
      if (linkMatch) return linkMatch;
    }

    return findBlockedDeliveryCoordinates(latitudeInput?.value, longitudeInput?.value);
  }

  function syncDeliveryLocationBlock(form) {
    const blockedArea = findBlockedDeliveryAreaFromForm(form);
    if (blockedArea) {
      setDeliveryLocationBlock(form, blockedArea);
      return blockedArea;
    }

    clearDeliveryLocationBlock(form);
    return null;
  }

  function setupDigitNormalization() {
    document.querySelectorAll("[data-normalize-digits]").forEach((field) => {
      const normalizeField = () => {
        field.value = normalizeDigits(field.value);
      };

      field.addEventListener("input", normalizeField);
      field.addEventListener("blur", normalizeField);
    });
  }

  function setupQuantitySteppers() {
    document.querySelectorAll("[data-lily-quantity-stepper]").forEach((stepper) => {
      const input = stepper.querySelector("input[type='number']");
      const minusButton = stepper.querySelector("[data-lily-quantity-minus]");
      const plusButton = stepper.querySelector("[data-lily-quantity-plus]");
      if (!input || !minusButton || !plusButton) return;

      const numericAttribute = (name, fallback) => {
        const value = Number.parseInt(normalizeDigits(input.getAttribute(name) || ""), 10);
        return Number.isFinite(value) ? value : fallback;
      };

      const step = Math.max(1, numericAttribute("step", 1));
      const minimum = numericAttribute("min", input.name === "quantity" ? 1 : 0);

      const maximum = () => {
        const value = Number.parseInt(normalizeDigits(input.getAttribute("max") || ""), 10);
        return Number.isFinite(value) ? value : null;
      };

      const currentValue = () => {
        const value = Number.parseInt(normalizeDigits(input.value), 10);
        return Number.isFinite(value) ? value : minimum;
      };

      const updateDisabledState = () => {
        const value = currentValue();
        const max = maximum();
        minusButton.disabled = value <= minimum;
        plusButton.disabled = max !== null && value >= max;
      };

      const setValue = (nextValue) => {
        const max = maximum();
        const cappedValue = max === null ? nextValue : Math.min(nextValue, max);
        input.value = String(Math.max(minimum, cappedValue));
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
        updateDisabledState();
      };

      minusButton.addEventListener("click", () => setValue(currentValue() - step));
      plusButton.addEventListener("click", () => setValue(currentValue() + step));
      input.addEventListener("input", updateDisabledState);
      input.addEventListener("change", updateDisabledState);
      updateDisabledState();
    });
  }

  const lilyCapacityApiBase = "https://mesh-story-bice.vercel.app/apps/lily-capacity";
  const deliveryScheduling = {
    minimumLeadDays: 2,
    maximumScheduleDays: 365,
    minimumDate: "",
    maximumDate: "",
    deliveryWindowLabelEn: "2 to 10 PM",
    deliveryWindowLabelAr: "من 2 إلى 10 مساءً",
    leadTimeExplanationEn:
      "Today and tomorrow are blocked. If you order Thursday, the earliest fulfillment date is Saturday; delivery runs 2 to 10 PM.",
    leadTimeExplanationAr:
      "يتم حجب اليوم والغد. إذا تم الطلب يوم الخميس، فأقرب تاريخ للاستلام أو التوصيل هو السبت؛ التوصيل من 2 إلى 10 مساءً.",
  };
  const storefrontLinks = {
    whatsappUrl: "https://wa.me/971547222329",
    instagramUrl: "https://www.instagram.com/mesh_story.snacks",
    googleLocationUrl: "https://www.google.com/maps/search/?api=1&query=Mesh%20Story%20Al%20Ain",
  };
  const storefrontDeliveryFees = {
    alAinFeeCents: 3000,
    outsideAlAinFeeCents: 4000,
    pickupFeeCents: 0,
  };
  const storefrontDeliveryOptions = {
    alAinEnabled: true,
    outsideAlAinEnabled: true,
    pickupEnabled: true,
  };
  const defaultStorefrontStatus = {
    mode: "open",
    messageEn:
      "Ordering is temporarily offline. Please refresh the page or try again in a few minutes.",
    messageAr: "نظام الطلبات متوقف مؤقتاً. يرجى تحديث الصفحة أو المحاولة بعد دقائق.",
  };
  const storefrontStatus = { ...defaultStorefrontStatus };
  const storefrontStatusModes = ["open", "coming_soon", "closed"];
  let capacityGroupKeys = ["swiss_roll", "cookies", "biscuit", "slice_cake", "donuts"];
  const capacityCalendarCache = new Map();
  let deliverySchedulingPromise = null;

  function normalizeCapacityGroupKey(value) {
    if (typeof value !== "string") return "";
    const normalized = value
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .replace(/_+/g, "_");
    return /^[a-z0-9]+(?:_[a-z0-9]+)*$/.test(normalized) ? normalized : "";
  }

  function syncCapacityGroups(value) {
    if (!Array.isArray(value)) return;

    const nextGroups = value
      .map((entry) => normalizeCapacityGroupKey(entry?.group || entry))
      .filter(Boolean);
    if (!nextGroups.length) return;

    capacityGroupKeys = Array.from(new Set(nextGroups));
    capacityCalendarCache.clear();
  }

  function capacityGroupLabel(group) {
    return String(group || "")
      .split("_")
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  }

  function isHalfStepCapacityGroup(group) {
    return String(group || "").includes("swiss") || String(group || "").includes("cookie");
  }

  function positiveIntegerOrFallback(value, fallback) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
  }

  function capacitySettingsEndpoint() {
    return window.LILY_CAPACITY_SETTINGS_URL || `${lilyCapacityApiBase}/settings`;
  }

  function featuredProductsEndpoint() {
    return window.LILY_FEATURED_PRODUCTS_URL || `${lilyCapacityApiBase}/featured-products`;
  }

  function capacityCalendarEndpoint(monthValue) {
    const configuredEndpoint =
      window.LILY_CAPACITY_CALENDAR_URL || `${lilyCapacityApiBase}/calendar`;
    const separator = configuredEndpoint.includes("?") ? "&" : "?";
    return `${configuredEndpoint}${separator}month=${encodeURIComponent(monthValue)}`;
  }

  function safeExternalUrl(value, fallback) {
    if (typeof value !== "string" || !value.trim()) return fallback;

    try {
      const url = new URL(value.trim());
      return url.protocol === "https:" || url.protocol === "http:" ? url.toString() : fallback;
    } catch {
      return fallback;
    }
  }

  function normalizeStorefrontLinks(value) {
    if (!value || typeof value !== "object") return null;

    return {
      whatsappUrl: safeExternalUrl(value.whatsappUrl, storefrontLinks.whatsappUrl),
      instagramUrl: safeExternalUrl(value.instagramUrl, storefrontLinks.instagramUrl),
      googleLocationUrl: safeExternalUrl(value.googleLocationUrl, storefrontLinks.googleLocationUrl),
    };
  }

  function normalizeStorefrontStatus(value, fallback = defaultStorefrontStatus) {
    if (!value || typeof value !== "object") return { ...fallback };

    const mode =
      typeof value.mode === "string" && storefrontStatusModes.includes(value.mode)
        ? value.mode
        : fallback.mode;
    const messageEn =
      typeof value.messageEn === "string" && value.messageEn.trim()
        ? value.messageEn.trim()
        : fallback.messageEn;
    const messageAr =
      typeof value.messageAr === "string" && value.messageAr.trim()
        ? value.messageAr.trim()
        : fallback.messageAr;

    return { mode, messageEn, messageAr };
  }

  function textFromStatusDataset(node, statusMode, language) {
    if (!node) return "";
    const key = statusMode === "closed" ? "closed" : "comingSoon";
    return node.dataset[`${key}${language === "ar" ? "Ar" : "En"}`] || "";
  }

  function setTranslatedText(node, en, ar) {
    if (!node || !en || !ar) return;
    node.setAttribute("data-i18n-en", en);
    node.setAttribute("data-i18n-ar", ar);
    node.textContent = translate(en, ar);
  }

  function applyStorefrontStatus(value = defaultStorefrontStatus) {
    const normalizedStatus = normalizeStorefrontStatus(value);
    Object.assign(storefrontStatus, normalizedStatus);
    const shouldShowNotice = storefrontStatus.mode !== "open";

    if (document.body) {
      document.body.setAttribute("data-lily-store-status", storefrontStatus.mode);
      document.body.classList.toggle("lily-store-is-closed", storefrontStatus.mode === "closed");
      document.body.classList.toggle("lily-store-checkout-blocked", shouldShowNotice);
    }

    document.querySelectorAll("[data-lily-store-status-note]").forEach((notice) => {
      notice.setAttribute("data-lily-store-status", storefrontStatus.mode);
      notice.hidden = !shouldShowNotice;
      notice.toggleAttribute("data-lily-store-status-ready", shouldShowNotice);

      const label = notice.querySelector("[data-lily-store-status-label]");
      const title = notice.querySelector("[data-lily-store-status-title]");
      const message = notice.querySelector("[data-lily-store-status-message]");

      const labelEn = textFromStatusDataset(label, storefrontStatus.mode, "en");
      const labelAr = textFromStatusDataset(label, storefrontStatus.mode, "ar");
      const titleEn = textFromStatusDataset(title, storefrontStatus.mode, "en");
      const titleAr = textFromStatusDataset(title, storefrontStatus.mode, "ar");
      const messageEn =
        storefrontStatus.mode === "closed"
          ? storefrontStatus.messageEn
          : textFromStatusDataset(message, storefrontStatus.mode, "en");
      const messageAr =
        storefrontStatus.mode === "closed"
          ? storefrontStatus.messageAr
          : textFromStatusDataset(message, storefrontStatus.mode, "ar");

      setTranslatedText(label, labelEn, labelAr);
      setTranslatedText(title, titleEn, titleAr);
      setTranslatedText(message, messageEn, messageAr);
    });

    document.dispatchEvent(
      new CustomEvent("lily:storefront-status-change", {
        detail: { ...storefrontStatus },
      })
    );
  }

  function isStorefrontClosed() {
    return storefrontStatus.mode !== "open";
  }

  function storefrontClosedMessage() {
    const noticeMessage = document
      .querySelector("[data-lily-store-status-message]")
      ?.textContent?.trim();
    if (noticeMessage) return noticeMessage;

    if (storefrontStatus.mode === "coming_soon") {
      return translate(
        "Ordering is temporarily offline while we get everything ready. Please refresh the page or try again in a few minutes.",
        "نظام الطلبات متوقف مؤقتاً بينما نجهز كل شيء. يرجى تحديث الصفحة أو المحاولة بعد دقائق."
      );
    }

    return translate(
      "Ordering is temporarily offline. Please refresh the page or try again in a few minutes.",
      "نظام الطلبات متوقف مؤقتاً. يرجى تحديث الصفحة أو المحاولة بعد دقائق."
    );
  }

  function showStorefrontClosedMessage(target) {
    const notice = document.querySelector("[data-lily-store-status-note]");
    if (notice) notice.scrollIntoView({ behavior: "smooth", block: "center" });
    window.alert(storefrontClosedMessage());
    if (target && typeof target.focus === "function") target.focus();
  }

  function normalizeStorefrontDeliveryFees(value) {
    if (!value || typeof value !== "object") return null;

    const normalizeFee = (fee, fallback) => {
      const parsed = Number.parseInt(fee, 10);
      return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
    };

    return {
      alAinFeeCents: normalizeFee(value.alAinFeeCents, storefrontDeliveryFees.alAinFeeCents),
      outsideAlAinFeeCents: normalizeFee(
        value.outsideAlAinFeeCents,
        storefrontDeliveryFees.outsideAlAinFeeCents
      ),
      pickupFeeCents: normalizeFee(value.pickupFeeCents, storefrontDeliveryFees.pickupFeeCents),
    };
  }

  function normalizeStorefrontDeliveryOptions(value) {
    if (!value || typeof value !== "object") return null;

    return {
      alAinEnabled:
        typeof value.alAinEnabled === "boolean"
          ? value.alAinEnabled
          : storefrontDeliveryOptions.alAinEnabled,
      outsideAlAinEnabled:
        typeof value.outsideAlAinEnabled === "boolean"
          ? value.outsideAlAinEnabled
          : storefrontDeliveryOptions.outsideAlAinEnabled,
      pickupEnabled:
        typeof value.pickupEnabled === "boolean"
          ? value.pickupEnabled
          : storefrontDeliveryOptions.pickupEnabled,
    };
  }

  function deliveryAvailabilityCopy(includePickupIntro) {
    const alAinAmount = formatAedAmount(storefrontDeliveryFees.alAinFeeCents);
    const outsideAmount = formatAedAmount(storefrontDeliveryFees.outsideAlAinFeeCents);
    const partsEn = [];
    const partsAr = [];

    if (includePickupIntro && storefrontDeliveryOptions.pickupEnabled) {
      partsEn.push("Pickup is free.");
      partsAr.push("الاستلام مجاني.");
    }

    if (
      storefrontDeliveryOptions.outsideAlAinEnabled &&
      storefrontDeliveryOptions.alAinEnabled
    ) {
      partsEn.push(
        `Delivery is assumed outside Al Ain at AED ${outsideAmount}; Al Ain delivery is AED ${alAinAmount} when available at checkout.`
      );
      partsAr.push(
        `يتم احتساب التوصيل كخارج العين بسعر ${outsideAmount} درهماً؛ وتوصيل العين ${alAinAmount} درهماً عند توفره في الدفع.`
      );
    } else if (storefrontDeliveryOptions.outsideAlAinEnabled) {
      partsEn.push(`Outside Al Ain delivery is AED ${outsideAmount}.`);
      partsAr.push(`التوصيل خارج العين ${outsideAmount} درهماً.`);
    } else if (storefrontDeliveryOptions.alAinEnabled) {
      partsEn.push(`Al Ain delivery is AED ${alAinAmount}.`);
      partsAr.push(`توصيل العين ${alAinAmount} درهماً.`);
    } else if (storefrontDeliveryOptions.pickupEnabled) {
      partsEn.push("Pickup is currently the only available option.");
      partsAr.push("الاستلام هو الخيار المتاح حالياً.");
    } else {
      partsEn.push("Ordering is temporarily offline. Please try again later.");
      partsAr.push("نظام الطلبات متوقف مؤقتاً. يرجى المحاولة لاحقاً.");
    }

    return {
      en: partsEn.join(" "),
      ar: partsAr.join(" "),
    };
  }

  function syncStorefrontDeliveryFees(root = document) {
    const summaryCopy = deliveryAvailabilityCopy(true);
    const deliveryCopy = deliveryAvailabilityCopy(false);

    root.querySelectorAll("[data-lily-delivery-fee-copy]").forEach((node) => {
      const copy = node.getAttribute("data-lily-delivery-fee-copy") === "summary"
        ? summaryCopy
        : deliveryCopy;
      node.setAttribute("data-i18n-en", copy.en);
      node.setAttribute("data-i18n-ar", copy.ar);
      node.textContent = translate(copy.en, copy.ar);
    });

    [
      {
        key: "al-ain",
        cents: storefrontDeliveryFees.alAinFeeCents,
      },
      {
        key: "outside-al-ain",
        cents: storefrontDeliveryFees.outsideAlAinFeeCents,
      },
    ].forEach(({ key, cents }) => {
      const amount = formatAedAmount(cents);
      const en = `AED ${amount}`;
      const ar = `${amount} درهماً`;

      root.querySelectorAll(`[data-lily-delivery-price="${key}"]`).forEach((node) => {
        node.setAttribute("data-i18n-en", en);
        node.setAttribute("data-i18n-ar", ar);
        node.textContent = translate(en, ar);
      });
    });

    document.dispatchEvent(new CustomEvent("lily:delivery-fees-change"));
  }

  function syncStorefrontLinks(root = document) {
    const targets = {
      whatsapp: storefrontLinks.whatsappUrl,
      instagram: storefrontLinks.instagramUrl,
      location: storefrontLinks.googleLocationUrl,
    };

    Object.entries(targets).forEach(([key, href]) => {
      root.querySelectorAll(`[data-lily-link="${key}"]`).forEach((node) => {
        node.setAttribute("href", href);
      });
    });
  }

  function normalizedFeaturedHandles(value) {
    if (!Array.isArray(value)) return [];

    return Array.from(
      new Set(
        value
          .map((handle) => (typeof handle === "string" ? handle.trim().toLowerCase() : ""))
          .filter((handle) => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle))
      )
    ).slice(0, 4);
  }

  function currentFeaturedHandles(grid) {
    return Array.from(grid.querySelectorAll("[data-lily-product-handle]"))
      .map((card) => card.getAttribute("data-lily-product-handle") || "")
      .filter(Boolean);
  }

  function sameHandles(first, second) {
    return first.length === second.length && first.every((handle, index) => handle === second[index]);
  }

  async function fetchFeaturedProduct(handle) {
    const response = await fetch(
      `/products/${encodeURIComponent(handle)}?section_id=lily-featured-product-data`,
      {
        headers: { Accept: "text/html" },
        cache: "no-store",
      }
    );

    if (!response.ok) return null;
    const html = await response.text();
    const section = new DOMParser().parseFromString(html, "text/html");
    const data = section.querySelector("[data-lily-featured-product-data]")?.textContent;
    if (!data) return null;

    const product = JSON.parse(data);
    return product?.handle === handle ? product : null;
  }

  function productImageUrl(product) {
    if (typeof product?.featured_image === "string") return product.featured_image;
    if (Array.isArray(product?.images) && typeof product.images[0] === "string") {
      return product.images[0];
    }
    return "";
  }

  function createLandingProductCard(product, handle) {
    const title = product?.title || handle;
    const titleAr = product?.titleAr || title;
    const url = product?.url || `/products/${handle}`;
    const imageUrl = productImageUrl(product);
    const card = document.createElement("a");
    card.className = "lily-landing-product";
    card.href = url;
    card.setAttribute("data-lily-featured-card", "");
    card.setAttribute("data-lily-product-handle", handle);

    const imageWrap = document.createElement("span");
    imageWrap.className = "lily-landing-product__image";

    if (imageUrl) {
      const image = document.createElement("img");
      image.src = imageUrl;
      image.alt = title;
      image.loading = "lazy";
      imageWrap.append(image);
    } else {
      const placeholder = document.createElement("span");
      placeholder.className = "lily-landing-product__placeholder";
      placeholder.textContent = "Mesh Story";
      imageWrap.append(placeholder);
    }

    const body = document.createElement("span");
    body.className = "lily-landing-product__body";

    const titleNode = document.createElement("strong");
    titleNode.textContent = title;
    titleNode.setAttribute("data-i18n-en", title);
    titleNode.setAttribute("data-i18n-ar", titleAr || title);

    const small = document.createElement("small");
    small.textContent = "Shop now";
    small.setAttribute("data-i18n-en", "Shop now");
    small.setAttribute("data-i18n-ar", "تسوق الآن");

    body.append(titleNode, small);
    card.append(imageWrap, body);
    return card;
  }

  async function setupLandingFeaturedProducts() {
    const grid = document.querySelector("[data-lily-featured-grid]");
    if (!grid) return;

    try {
      const response = await fetch(featuredProductsEndpoint(), {
        headers: { Accept: "application/json" },
        cache: "no-store",
      });
      if (!response.ok) return;

      const payload = await response.json();
      const handles = normalizedFeaturedHandles(payload?.handles);
      if (!handles.length || sameHandles(handles, currentFeaturedHandles(grid))) return;

      const products = await Promise.all(handles.map((handle) => fetchFeaturedProduct(handle)));
      if (products.some((product) => !product)) return;

      const cards = handles
        .map((handle, index) => createLandingProductCard(products[index], handle))
        .filter(Boolean);

      if (!cards.length) return;
      grid.replaceChildren(...cards);
      applyLanguage(getInitialLanguage());
    } catch (error) {
      console.warn("Could not load Mesh Story featured products.", error);
    }
  }

  function normalizeDeliveryScheduling(payload) {
    if (!payload || typeof payload !== "object") return null;

    const minimumLeadDays = positiveIntegerOrFallback(
      payload.minimumLeadDays,
      deliveryScheduling.minimumLeadDays
    );
    const maximumScheduleDays = positiveIntegerOrFallback(
      payload.maximumScheduleDays,
      deliveryScheduling.maximumScheduleDays
    );
    const deliveryWindowLabelEn =
      typeof payload.deliveryWindowLabelEn === "string" && payload.deliveryWindowLabelEn.trim()
        ? payload.deliveryWindowLabelEn.trim()
        : deliveryScheduling.deliveryWindowLabelEn;
    const deliveryWindowLabelAr =
      typeof payload.deliveryWindowLabelAr === "string" && payload.deliveryWindowLabelAr.trim()
        ? payload.deliveryWindowLabelAr.trim()
        : deliveryScheduling.deliveryWindowLabelAr;

    return {
      minimumLeadDays,
      maximumScheduleDays,
      minimumDate:
        typeof payload.minimumDate === "string" && parseDateInputValue(payload.minimumDate)
          ? payload.minimumDate
          : "",
      maximumDate:
        typeof payload.maximumDate === "string" && parseDateInputValue(payload.maximumDate)
          ? payload.maximumDate
          : "",
      deliveryWindowLabelEn,
      deliveryWindowLabelAr,
      leadTimeExplanationEn:
        typeof payload.leadTimeExplanationEn === "string" && payload.leadTimeExplanationEn.trim()
          ? payload.leadTimeExplanationEn.trim()
          : deliveryScheduling.leadTimeExplanationEn,
      leadTimeExplanationAr:
        typeof payload.leadTimeExplanationAr === "string" && payload.leadTimeExplanationAr.trim()
          ? payload.leadTimeExplanationAr.trim()
          : deliveryScheduling.leadTimeExplanationAr,
    };
  }

  function syncDeliverySchedulingCopy(root = document) {
    const helpText = translate(
      deliveryScheduling.leadTimeExplanationEn,
      deliveryScheduling.leadTimeExplanationAr
    );

    root.querySelectorAll("[data-lily-delivery-schedule-note]").forEach((node) => {
      node.setAttribute("data-i18n-en", deliveryScheduling.leadTimeExplanationEn);
      node.setAttribute("data-i18n-ar", deliveryScheduling.leadTimeExplanationAr);
      node.textContent = helpText;
    });

    root.querySelectorAll("[data-lily-delivery-window]").forEach((input) => {
      input.value = deliveryScheduling.deliveryWindowLabelEn;
    });
  }

  function loadDeliveryScheduling() {
    if (deliverySchedulingPromise) return deliverySchedulingPromise;

    deliverySchedulingPromise = fetch(capacitySettingsEndpoint(), {
      headers: { Accept: "application/json" },
      cache: "no-store",
    })
      .then((response) => {
        if (!response.ok) throw new Error("Capacity settings unavailable");
        return response.json();
      })
      .then((payload) => {
        syncCapacityGroups(payload?.capacityGroups);
        const normalized = normalizeDeliveryScheduling(payload);
        if (normalized) Object.assign(deliveryScheduling, normalized);
        const normalizedLinks = normalizeStorefrontLinks(payload?.storefrontLinks);
        if (normalizedLinks) Object.assign(storefrontLinks, normalizedLinks);
        applyStorefrontStatus(payload?.storefrontStatus);
        const normalizedFees = normalizeStorefrontDeliveryFees(payload?.deliveryFees);
        if (normalizedFees) Object.assign(storefrontDeliveryFees, normalizedFees);
        const normalizedDeliveryOptions = normalizeStorefrontDeliveryOptions(
          payload?.deliveryOptions
        );
        if (normalizedDeliveryOptions) {
          Object.assign(storefrontDeliveryOptions, normalizedDeliveryOptions);
        }
        syncDeliverySchedulingCopy();
        syncStorefrontLinks();
        syncStorefrontDeliveryFees();
        document.dispatchEvent(new CustomEvent("lily:delivery-scheduling-change"));
        return deliveryScheduling;
      })
      .catch((error) => {
        console.warn("Could not load Mesh Story capacity settings.", error);
        applyStorefrontStatus(defaultStorefrontStatus);
        syncDeliverySchedulingCopy();
        syncStorefrontLinks();
        syncStorefrontDeliveryFees();
        return deliveryScheduling;
      });

    return deliverySchedulingPromise;
  }

  function normalizeCapacityCalendar(payload) {
    const normalizedScheduling = normalizeDeliveryScheduling(payload?.scheduling);
    if (normalizedScheduling) {
      Object.assign(deliveryScheduling, normalizedScheduling);
      syncDeliverySchedulingCopy();
      document.dispatchEvent(new CustomEvent("lily:delivery-scheduling-change"));
    }

    const days = new Map();
    const payloadDays = Array.isArray(payload?.days) ? payload.days : [];

    payloadDays.forEach((day) => {
      const date = typeof day?.date === "string" ? day.date : "";
      if (!parseDateInputValue(date)) return;

      const byGroup = {};
      const groups = Array.isArray(day.groups) ? day.groups : [];
      groups.forEach((entry) => {
        const group = normalizeCapacityGroupKey(entry?.group);
        if (!group) return;
        if (!capacityGroupKeys.includes(group)) {
          capacityGroupKeys = Array.from(new Set([...capacityGroupKeys, group]));
        }

        const remaining = Number.parseInt(entry.remaining, 10);
        const limit = Number.parseInt(entry.limit, 10);
        const used = Number.parseInt(entry.used, 10);
        byGroup[group] = {
          remaining: Number.isFinite(remaining) ? Math.max(0, remaining) : 0,
          limit: Number.isFinite(limit) ? Math.max(0, limit) : 0,
          used: Number.isFinite(used) ? Math.max(0, used) : 0,
          closed: entry.closed === true,
        };
      });

      days.set(date, {
        date,
        status: typeof day.status === "string" ? day.status : "",
        groups: byGroup,
      });
    });

    return {
      month: typeof payload?.month === "string" ? payload.month : "",
      days,
    };
  }

  async function fetchCapacityCalendar(monthValue) {
    if (!monthValue) return { month: "", days: new Map() };

    if (!capacityCalendarCache.has(monthValue)) {
      const promise = fetch(capacityCalendarEndpoint(monthValue), {
        headers: { Accept: "application/json" },
        cache: "no-store",
      })
        .then((response) => {
          if (!response.ok) throw new Error("Capacity calendar unavailable");
          return response.json();
        })
        .then(normalizeCapacityCalendar)
        .catch((error) => {
          capacityCalendarCache.delete(monthValue);
          throw error;
        });

      capacityCalendarCache.set(monthValue, promise);
    }

    return capacityCalendarCache.get(monthValue);
  }

  function toLocalDateInputValue(date) {
    const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return offsetDate.toISOString().slice(0, 10);
  }

  function parseDateInputValue(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return null;
    const [year, month, day] = value.split("-").map((part) => Number.parseInt(part, 10));
    const parsed = new Date(year, month - 1, day);
    parsed.setHours(0, 0, 0, 0);
    if (parsed.getFullYear() !== year || parsed.getMonth() !== month - 1 || parsed.getDate() !== day) return null;
    return parsed;
  }

  function minimumDeliveryDateValue() {
    if (deliveryScheduling.minimumDate) return deliveryScheduling.minimumDate;

    const minimumDate = new Date();
    minimumDate.setHours(0, 0, 0, 0);
    minimumDate.setDate(minimumDate.getDate() + deliveryScheduling.minimumLeadDays);
    return toLocalDateInputValue(minimumDate);
  }

  function maximumDeliveryDateValue() {
    if (deliveryScheduling.maximumDate) return deliveryScheduling.maximumDate;

    const maximumDate = new Date();
    maximumDate.setHours(0, 0, 0, 0);
    maximumDate.setDate(maximumDate.getDate() + deliveryScheduling.maximumScheduleDays);
    return toLocalDateInputValue(maximumDate);
  }

  function formatDeliveryDateForMessage(value) {
    const date = parseDateInputValue(value);
    if (!date) return value;
    const locale = currentLanguage() === "ar" ? "ar-AE" : "en-AE";
    return date.toLocaleDateString(locale, { day: "numeric", month: "short", year: "numeric" });
  }

  function minimumDeliveryDateMessage(minimumValue) {
    const formattedDate = formatDeliveryDateForMessage(minimumValue);
    return translate(
      `Please choose ${formattedDate} or later. ${deliveryScheduling.leadTimeExplanationEn}`,
      `يرجى اختيار ${formattedDate} أو تاريخ لاحق. ${deliveryScheduling.leadTimeExplanationAr}`
    );
  }

  function maximumDeliveryDateMessage(maximumValue) {
    const formattedDate = formatDeliveryDateForMessage(maximumValue);
    return translate(
      `Please choose ${formattedDate} or earlier. Orders can be scheduled up to ${deliveryScheduling.maximumScheduleDays} days ahead.`,
      `يرجى اختيار ${formattedDate} أو تاريخ أسبق. يمكن جدولة الطلبات حتى ${deliveryScheduling.maximumScheduleDays} يوم مقدماً.`
    );
  }

  function deliveryRootForForm(form) {
    return (form && typeof form.closest === "function" && form.closest(".lily-cart-page")) || document;
  }

  function deliveryDateInputForForm(form) {
    const root = deliveryRootForForm(form);
    return (
      (form && typeof form.querySelector === "function" && form.querySelector("[data-lily-delivery-date]")) ||
      root.querySelector("[data-lily-delivery-date]")
    );
  }

  function addCalendarMonths(date, offset) {
    return new Date(date.getFullYear(), date.getMonth() + offset, 1);
  }

  function calendarMonthKey(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
  }

  function calendarMonthStartForValue(value) {
    const parsed = parseDateInputValue(value) || parseDateInputValue(minimumDeliveryDateValue()) || new Date();
    return new Date(parsed.getFullYear(), parsed.getMonth(), 1);
  }

  function formatDeliveryDateForDisplay(value) {
    const date = parseDateInputValue(value);
    if (!date) return translate("Choose date", "اختاري التاريخ");

    const locale = currentLanguage() === "ar" ? "ar-AE" : "en-AE";
    return date.toLocaleDateString(locale, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  function calendarWeekdayLabels() {
    const locale = currentLanguage() === "ar" ? "ar-AE" : "en-AE";
    const sunday = new Date(2026, 6, 12);
    return Array.from({ length: 7 }, (_unused, index) => {
      const date = new Date(sunday);
      date.setDate(sunday.getDate() + index);
      return date.toLocaleDateString(locale, { weekday: "short" });
    });
  }

  function cartCapacityTotals(form) {
    const totals = capacityGroupKeys.reduce((result, group) => {
      result[group] = 0;
      return result;
    }, {});
    const root = form && typeof form.querySelectorAll === "function" ? form : document;

    root.querySelectorAll("[data-lily-cart-quantity]").forEach((input) => {
      const group = normalizeCapacityGroupKey(input.getAttribute("data-lily-inventory-group"));
      if (!group || !capacityGroupKeys.includes(group)) return;

      const quantity = Math.max(0, Number.parseInt(normalizeDigits(input.value), 10) || 0);
      const units = Math.max(
        1,
        Number.parseInt(input.getAttribute("data-lily-inventory-units") || "1", 10) || 1
      );
      totals[group] += quantity * units;
    });

    return totals;
  }

  function calendarDayStateForForm(form, day) {
    const totals = cartCapacityTotals(form);
    const activeGroups = capacityGroupKeys.filter((group) => (totals[group] || 0) > 0);
    if (!activeGroups.length) return "available";

    if (!day) return "unavailable";

    const hasClosedGroup = activeGroups.some((group) => day.groups[group]?.closed);
    if (hasClosedGroup || day.status === "closed") return "unavailable";

    const hasSoldOutGroup = activeGroups.some((group) => {
      const groupAvailability = day.groups[group];
      if (!groupAvailability) return true;
      return (totals[group] || 0) > groupAvailability.remaining;
    });

    return hasSoldOutGroup ? "sold-out" : "available";
  }

  function setDeliveryDateStatus(dateInput, message, tone) {
    const status = dateInput.closest(".lily-delivery-picker")?.querySelector("[data-lily-delivery-date-status]");
    if (!status) return;
    status.textContent = message || "";
    status.hidden = !message;
    status.classList.toggle("is-error", tone === "error");
  }

  function setupMinimumDeliveryDate(form, options = {}) {
    const dateInput = deliveryDateInputForForm(form);
    if (!dateInput) return true;

    const minimumValue = minimumDeliveryDateValue();
    const maximumValue = maximumDeliveryDateValue();
    dateInput.min = minimumValue;
    dateInput.max = maximumValue;

    const parsedDate = parseDateInputValue(dateInput.value);
    const isBeforeMinimum = dateInput.value && (!parsedDate || dateInput.value < minimumValue);
    const isAfterMaximum = dateInput.value && parsedDate && dateInput.value > maximumValue;
    if (!dateInput.value && options.requireValue) {
      const message = minimumDeliveryDateMessage(minimumValue);
      dateInput.setCustomValidity(message);
      setDeliveryDateStatus(dateInput, message, "error");
      return false;
    }

    if (!dateInput.value || isBeforeMinimum || isAfterMaximum) {
      const adjustedValue = isAfterMaximum ? maximumValue : minimumValue;
      dateInput.value = adjustedValue;
      dateInput.setCustomValidity("");
      setDeliveryDateStatus(
        dateInput,
        options.showAdjustedMessage
          ? isAfterMaximum
            ? translate(
                `Latest fulfillment date is ${formatDeliveryDateForMessage(maximumValue)}.`,
                `آخر تاريخ للاستلام أو التوصيل هو ${formatDeliveryDateForMessage(maximumValue)}.`
              )
            : translate(
                `Earliest fulfillment date is ${formatDeliveryDateForMessage(minimumValue)}. Delivery runs ${deliveryScheduling.deliveryWindowLabelEn}.`,
                `أقرب تاريخ للاستلام أو التوصيل هو ${formatDeliveryDateForMessage(minimumValue)}. التوصيل ${deliveryScheduling.deliveryWindowLabelAr}.`
              )
          : "",
        ""
      );
      return true;
    }

    if (dateInput.value > maximumValue) {
      const message = maximumDeliveryDateMessage(maximumValue);
      dateInput.setCustomValidity(message);
      setDeliveryDateStatus(dateInput, message, "error");
      return false;
    }

    dateInput.setCustomValidity("");
    setDeliveryDateStatus(dateInput, "", "");
    return true;
  }

  function setupDeliveryDateField(form) {
    const dateInput = deliveryDateInputForForm(form);
    if (!dateInput) return;

    const checkoutButton = document.querySelector(".lily-checkout-button");
    const picker = dateInput.closest("[data-lily-date-picker]");
    const trigger = picker?.querySelector("[data-lily-date-trigger]");
    const display = picker?.querySelector("[data-lily-date-display]");
    const calendar = picker?.querySelector("[data-lily-date-calendar]");
    let visibleMonth = calendarMonthStartForValue(dateInput.value);
    let renderToken = 0;

    setupMinimumDeliveryDate(form);
    syncDeliverySchedulingCopy(form.closest(".lily-cart-page") || document);
    if (!dateInput.id) dateInput.id = "LilyDeliveryDate";

    function updateDateDisplay() {
      if (!display) return;
      const text = formatDeliveryDateForDisplay(dateInput.value);
      display.textContent = text;
      display.setAttribute("data-i18n-en", dateInput.value ? formatDeliveryDateForDisplay(dateInput.value) : "Choose date");
      display.setAttribute("data-i18n-ar", dateInput.value ? formatDeliveryDateForDisplay(dateInput.value) : "اختاري التاريخ");
    }

    function setCalendarOpen(open) {
      if (!trigger || !calendar) return;

      trigger.setAttribute("aria-expanded", String(open));
      calendar.hidden = !open;
      if (open) renderCalendar();
    }

    function selectCalendarDate(value) {
      dateInput.value = value;
      dateInput.setCustomValidity("");
      updateDateDisplay();
      setCalendarOpen(false);
      dateInput.dispatchEvent(new Event("input", { bubbles: true }));
      dateInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function buildCalendarDayButton(date, monthDate, calendarData, minimumValue, maximumValue) {
      const dateValue = toLocalDateInputValue(date);
      const inVisibleMonth = date.getMonth() === monthDate.getMonth();
      const isOutOfRange = dateValue < minimumValue || dateValue > maximumValue;
      const day = calendarData?.days?.get(dateValue);
      const state = inVisibleMonth && !isOutOfRange && calendarData ? calendarDayStateForForm(form, day) : "loading";
      const button = document.createElement("button");
      const number = document.createElement("strong");

      button.type = "button";
      button.className = "lily-calendar__day";
      button.dataset.date = dateValue;
      button.setAttribute("aria-label", formatDeliveryDateForMessage(dateValue));

      number.textContent = String(date.getDate());
      button.append(number);

      if (!inVisibleMonth) {
        button.classList.add("is-muted");
        button.disabled = true;
        return button;
      }

      if (dateValue === toLocalDateInputValue(new Date())) {
        button.classList.add("is-today");
      }

      if (dateInput.value === dateValue) {
        button.classList.add("is-selected");
        button.setAttribute("aria-pressed", "true");
      }

      if (isOutOfRange) {
        button.classList.add("is-impossible");
        button.disabled = true;
        button.setAttribute(
          "aria-label",
          `${formatDeliveryDateForMessage(dateValue)} - ${translate("Impossible", "غير ممكن")}`
        );
        return button;
      }

      if (!calendarData) {
        button.classList.add("is-loading");
        button.disabled = true;
        button.setAttribute(
          "aria-label",
          `${formatDeliveryDateForMessage(dateValue)} - ${translate("Checking", "جار الفحص")}`
        );
        return button;
      }

      if (state === "sold-out") {
        button.classList.add("is-sold-out");
        button.disabled = true;
        button.setAttribute(
          "aria-label",
          `${formatDeliveryDateForMessage(dateValue)} - ${translate("Unavailable", "غير متاح")}`
        );
        return button;
      }

      if (state === "unavailable") {
        button.classList.add("is-unavailable");
        button.disabled = true;
        button.setAttribute(
          "aria-label",
          `${formatDeliveryDateForMessage(dateValue)} - ${translate("Unavailable", "غير متاح")}`
        );
        return button;
      }

      button.classList.add("is-available");
      button.setAttribute(
        "aria-label",
        `${formatDeliveryDateForMessage(dateValue)} - ${translate("Available", "متاح")}`
      );
      button.addEventListener("click", () => selectCalendarDate(dateValue));
      return button;
    }

    function renderCalendar(calendarData = null) {
      if (!calendar) return;

      const currentToken = ++renderToken;
      const monthDate = new Date(visibleMonth);
      const monthValue = calendarMonthKey(monthDate);
      const minimumValue = minimumDeliveryDateValue();
      const maximumValue = maximumDeliveryDateValue();
      const minimumDate = parseDateInputValue(minimumValue);
      const maximumDate = parseDateInputValue(maximumValue);
      const firstOfMonth = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
      const startDate = new Date(firstOfMonth);
      startDate.setDate(firstOfMonth.getDate() - firstOfMonth.getDay());

      const header = document.createElement("div");
      header.className = "lily-calendar__header";

      const previousButton = document.createElement("button");
      previousButton.type = "button";
      previousButton.className = "lily-calendar__nav";
      previousButton.textContent = "‹";
      previousButton.setAttribute("aria-label", translate("Previous month", "الشهر السابق"));
      previousButton.disabled = minimumDate && new Date(monthDate.getFullYear(), monthDate.getMonth(), 0) < minimumDate;
      previousButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        visibleMonth = addCalendarMonths(visibleMonth, -1);
        renderCalendar();
      });

      const nextButton = document.createElement("button");
      nextButton.type = "button";
      nextButton.className = "lily-calendar__nav";
      nextButton.textContent = "›";
      nextButton.setAttribute("aria-label", translate("Next month", "الشهر التالي"));
      nextButton.disabled = maximumDate && new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 1) > maximumDate;
      nextButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        visibleMonth = addCalendarMonths(visibleMonth, 1);
        renderCalendar();
      });

      const title = document.createElement("strong");
      title.className = "lily-calendar__title";
      title.textContent = monthDate.toLocaleDateString(currentLanguage() === "ar" ? "ar-AE" : "en-AE", {
        month: "long",
        year: "numeric",
      });

      header.append(previousButton, title, nextButton);

      const weekdays = document.createElement("div");
      weekdays.className = "lily-calendar__weekdays";
      calendarWeekdayLabels().forEach((weekday) => {
        const day = document.createElement("span");
        day.className = "lily-calendar__weekday";
        day.textContent = weekday;
        weekdays.append(day);
      });

      const grid = document.createElement("div");
      grid.className = "lily-calendar__grid";

      Array.from({ length: 42 }, (_unused, index) => {
        const date = new Date(startDate);
        date.setDate(startDate.getDate() + index);
        grid.append(buildCalendarDayButton(date, monthDate, calendarData, minimumValue, maximumValue));
      });

      const legend = document.createElement("div");
      legend.className = "lily-calendar__legend";
      legend.setAttribute(
        "aria-label",
        translate("Green available, red unavailable, gray impossible", "الأخضر متاح، الأحمر غير متاح، الرمادي غير ممكن")
      );
      [
        ["is-available", translate("Available", "متاح")],
        ["is-unavailable", translate("Unavailable", "غير متاح")],
        ["is-impossible", translate("Impossible", "غير ممكن")],
      ].forEach(([className, labelText]) => {
        const swatch = document.createElement("span");
        swatch.className = `lily-calendar__legend-swatch ${className}`;
        swatch.setAttribute("aria-label", labelText);
        legend.append(swatch);
      });

      calendar.replaceChildren(header, weekdays, grid, legend);

      if (!calendarData) {
        fetchCapacityCalendar(monthValue)
          .then((monthData) => {
            if (currentToken !== renderToken || calendar.hidden) return;
            renderCalendar(monthData);
          })
          .catch(() => {
            if (currentToken !== renderToken || calendar.hidden) return;
            calendar.querySelectorAll(".lily-calendar__day.is-loading").forEach((button) => {
              button.classList.remove("is-loading");
              button.classList.add("is-unavailable");
              button.disabled = true;
              const dateValue = button.getAttribute("data-date") || "";
              button.setAttribute(
                "aria-label",
                `${formatDeliveryDateForMessage(dateValue)} - ${translate("Unavailable", "غير متاح")}`
              );
            });
          });
      }
    }

    let lastDateValue = dateInput.value;
    const enforceDate = () => {
      const previousDateValue = dateInput.value;
      setupMinimumDeliveryDate(form);
      visibleMonth = calendarMonthStartForValue(dateInput.value);
      updateDateDisplay();
      lastDateValue = dateInput.value;
      if (dateInput.value !== previousDateValue) {
        dateInput.dispatchEvent(new Event("input", { bubbles: true }));
        dateInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    };

    dateInput.addEventListener("input", enforceDate);
    dateInput.addEventListener("change", enforceDate);
    dateInput.addEventListener("blur", enforceDate);
    dateInput.addEventListener("invalid", (event) => {
      if (!setupMinimumDeliveryDate(form, { requireValue: true, showAdjustedMessage: true })) return;
      event.preventDefault();
    });
    if (trigger) {
      trigger.addEventListener("click", () => setCalendarOpen(calendar ? calendar.hidden : false));
    }
    document.addEventListener("click", (event) => {
      if (!picker || !calendar || calendar.hidden) return;
      if (picker.contains(event.target)) return;
      setCalendarOpen(false);
    });
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" || !calendar || calendar.hidden) return;
      setCalendarOpen(false);
      trigger?.focus();
    });
    if (checkoutButton) checkoutButton.addEventListener("click", enforceDate);
    document.addEventListener("lily:language-change", () => {
      syncDeliverySchedulingCopy(form.closest(".lily-cart-page") || document);
      setupMinimumDeliveryDate(form);
      updateDateDisplay();
      if (calendar && !calendar.hidden) renderCalendar();
    });
    document.addEventListener("lily:delivery-scheduling-change", () => {
      enforceDate();
      if (calendar && !calendar.hidden) renderCalendar();
    });
    loadDeliveryScheduling().then(enforceDate);
    updateDateDisplay();
    window.setTimeout(() => setupMinimumDeliveryDate(form), 0);
    window.setInterval(() => {
      if (dateInput.value === lastDateValue) return;
      enforceDate();
    }, 450);
  }

  function validateDeliveryDate(form) {
    const dateInput = deliveryDateInputForForm(form);
    if (!dateInput) return true;

    setupMinimumDeliveryDate(form, { requireValue: true, showAdjustedMessage: true });
    if (dateInput.checkValidity()) return true;

    dateInput.reportValidity();
    dateInput.closest(".lily-delivery-picker")?.scrollIntoView({ behavior: "smooth", block: "center" });
    return false;
  }

  function setupCartCheckoutDelivery() {
    const form = document.querySelector("[data-lily-cart-update-form]");
    const dateInput = document.querySelector("[data-lily-delivery-date]");
    if (!form || !dateInput) return;

    setupMinimumDeliveryDate(document);

    form.addEventListener("submit", (event) => {
      const submitter = event.submitter;
      if (submitter && submitter.getAttribute("name") !== "checkout") return;

      if (isStorefrontClosed()) {
        event.preventDefault();
        showStorefrontClosedMessage(submitter || form.querySelector(".lily-checkout-button"));
        return;
      }

      if (validateDeliveryDate(form)) return;

      event.preventDefault();
    });
  }

  function setStorefrontClosedDisabled(button, closed) {
    if (!button) return;

    if (closed) {
      if (!button.hasAttribute("data-lily-store-closed-was-disabled")) {
        button.setAttribute(
          "data-lily-store-closed-was-disabled",
          button.disabled ? "true" : "false"
        );
      }
      button.disabled = true;
      return;
    }

    if (!button.hasAttribute("data-lily-store-closed-was-disabled")) return;

    button.disabled =
      button.getAttribute("data-lily-store-closed-was-disabled") === "true";
    button.removeAttribute("data-lily-store-closed-was-disabled");
  }

  function setupStorefrontStatusGuards() {
    function syncClosedButtons() {
      const closed = isStorefrontClosed();
      document.querySelectorAll(".lily-product-form button[type='submit'], .lily-checkout-button").forEach((button) => {
        setStorefrontClosedDisabled(button, closed);
      });
    }

    document.addEventListener(
      "submit",
      (event) => {
        if (!isStorefrontClosed()) return;

        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const isProductForm = form.classList.contains("lily-product-form");
        const submitter = event.submitter;
        const isCheckoutForm =
          form.matches("[data-lily-cart-update-form]") &&
          (!submitter || submitter.getAttribute("name") === "checkout");

        if (!isProductForm && !isCheckoutForm) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        showStorefrontClosedMessage(submitter || form);
      },
      true
    );

    document.addEventListener("lily:storefront-status-change", syncClosedButtons);
    document.addEventListener("lily:language-change", syncClosedButtons);
    document.addEventListener("change", syncClosedButtons);
    window.setTimeout(syncClosedButtons, 0);
  }

  function setupAddressSummary(form) {
    const summaryInput = form.querySelector("[data-lily-address-summary]");
    const addressFields = Array.from(form.querySelectorAll("[data-lily-address-field]"));
    if (!summaryInput || addressFields.length === 0) return () => {};

    const updateSummary = () => {
      const pieces = addressFields
        .map((field) => {
          const label = form.querySelector(`label[for="${field.id}"]`);
          const labelText = label ? label.textContent.trim() : field.name.replace(/^attributes\[|\]$/g, "");
          const value = normalizeDigits(field.value).trim();
          return value ? `${labelText}: ${value}` : "";
        })
        .filter(Boolean);

      summaryInput.value = pieces.join(" | ");
    };

    addressFields.forEach((field) => {
      field.addEventListener("input", updateSummary);
      field.addEventListener("change", updateSummary);
    });
    updateSummary();
    return updateSummary;
  }

  function isInsideUae(lat, lng) {
    return lat >= uaeBounds.south && lat <= uaeBounds.north && lng >= uaeBounds.west && lng <= uaeBounds.east;
  }

  function toRadians(degrees) {
    return (degrees * Math.PI) / 180;
  }

  function distanceKmBetween(start, end) {
    const earthRadiusKm = 6371;
    const deltaLat = toRadians(end.lat - start.lat);
    const deltaLng = toRadians(end.lng - start.lng);
    const startLat = toRadians(start.lat);
    const endLat = toRadians(end.lat);
    const a =
      Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(startLat) * Math.cos(endLat) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return earthRadiusKm * c;
  }

  function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps && window.google.maps.places) {
      return Promise.resolve(window.google);
    }

    if (window.lilyGoogleMapsPromise) {
      return window.lilyGoogleMapsPromise;
    }

    window.lilyGoogleMapsPromise = new Promise((resolve, reject) => {
      const callbackName = `lilyGoogleMapsReady${Date.now()}`;
      window[callbackName] = () => {
        delete window[callbackName];
        resolve(window.google);
      };

      const script = document.createElement("script");
      const params = new URLSearchParams({
        key: apiKey,
        libraries: "places",
        region: "AE",
        language: currentLanguage(),
        callback: callbackName,
      });

      script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
      script.async = true;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.lilyGoogleMapsPromise;
  }

  function setMapStatus(statusNode, messageEn, messageAr, tone) {
    if (!statusNode) return;
    statusNode.setAttribute("data-i18n-en", messageEn);
    statusNode.setAttribute("data-i18n-ar", messageAr);
    statusNode.textContent = translate(messageEn, messageAr);
    statusNode.classList.toggle("is-error", tone === "error");
  }

  function fillAddressFromPlace(form, place) {
    if (!place || !Array.isArray(place.address_components)) return;

    const getComponent = (type, shortName = false) => {
      const component = place.address_components.find((part) => part.types.includes(type));
      return component ? component[shortName ? "short_name" : "long_name"] : "";
    };

    const country = getComponent("country", true);
    if (country && country !== "AE") return;

    const streetInput = form.querySelector("[data-lily-street]");
    const emirateSelect = form.querySelector("[data-lily-emirate]");
    const postalInput = form.querySelector("[data-lily-postal-code]");

    const street = [getComponent("route"), getComponent("sublocality"), getComponent("locality")]
      .filter(Boolean)
      .join(", ");
    const emirate = getComponent("administrative_area_level_1") || getComponent("locality");
    const postalCode = getComponent("postal_code");

    if (streetInput && street) streetInput.value = street;
    if (postalInput && postalCode) postalInput.value = normalizeDigits(postalCode);

    if (emirateSelect && emirate) {
      const matchingOption = Array.from(emirateSelect.options).find((option) => {
        return option.value.toLowerCase() === emirate.toLowerCase();
      });
      if (matchingOption) emirateSelect.value = matchingOption.value;
    }

    [streetInput, postalInput, emirateSelect].forEach((field) => {
      if (field) field.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function setupGoogleMapPicker(form) {
    const apiKey = window.LILY_GOOGLE_MAPS_KEY;
    const root = form.closest(".lily-cart-page") || document;
    const mapNode = root.querySelector("[data-lily-map]");
    const searchInput = root.querySelector("[data-lily-location-search]");
    const statusNode = root.querySelector("[data-lily-location-status]");
    const locateButton = root.querySelector("[data-lily-geolocate]");
    const latInput = root.querySelector("[data-lily-lat]");
    const lngInput = root.querySelector("[data-lily-lng]");
    const placeIdInput = root.querySelector("[data-lily-place-id]");
    const mapLinkInput = root.querySelector("[data-lily-map-link]");

    if (!mapNode || !latInput || !lngInput) return;
    syncDeliveryLocationBlock(form);

    const setCoordinates = (lat, lng, messageEn, messageAr) => {
      if (!isInsideUae(lat, lng)) {
        setMapStatus(
          statusNode,
          "Please choose a delivery location inside the UAE.",
          "يرجى اختيار موقع توصيل داخل الإمارات.",
          "error"
        );
        return false;
      }

      const blockedArea = findBlockedDeliveryCoordinates(lat, lng);
      if (blockedArea) {
        setDeliveryLocationBlock(form, blockedArea);
        return false;
      }

      clearDeliveryLocationBlock(form);
      latInput.value = lat.toFixed(7);
      lngInput.value = lng.toFixed(7);
      if (searchInput) searchInput.setCustomValidity("");
      if (mapLinkInput) mapLinkInput.setCustomValidity("");
      if (mapLinkInput) mapLinkInput.value = `https://www.google.com/maps?q=${lat.toFixed(7)},${lng.toFixed(7)}`;
      setMapStatus(
        statusNode,
        messageEn || "Delivery pin saved.",
        messageAr || "تم حفظ موقع التوصيل."
      );
      form.dispatchEvent(new Event("input", { bubbles: true }));
      return true;
    };

    if (locateButton) {
      locateButton.addEventListener("click", () => {
        if (!navigator.geolocation) {
          setMapStatus(statusNode, "Location is not available in this browser.", "الموقع غير متاح في هذا المتصفح.");
          return;
        }

        setMapStatus(statusNode, "Finding your location...", "جاري تحديد موقعك...");
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            if (!setCoordinates(lat, lng, "Current location saved.", "تم حفظ موقعك الحالي.")) return;

            if (window.lilyDeliveryMap && window.lilyDeliveryMarker) {
              const location = { lat, lng };
              window.lilyDeliveryMap.setCenter(location);
              window.lilyDeliveryMap.setZoom(14);
              window.lilyDeliveryMarker.setMap(window.lilyDeliveryMap);
              window.lilyDeliveryMarker.setPosition(location);
            }
          },
          () => {
            setMapStatus(statusNode, "Could not access your location.", "تعذر الوصول إلى موقعك.");
          },
          { enableHighAccuracy: true, timeout: 10000 }
        );
      });
    }

    if (!apiKey) {
      mapNode.classList.add("is-disabled");
      setMapStatus(
        statusNode,
        "Google Maps is not enabled yet. Paste a Google Maps link below.",
        "خرائط Google غير مفعلة حالياً. الصقي رابط خرائط Google أدناه."
      );
      return;
    }

    loadGoogleMaps(apiKey)
      .then((google) => {
        const hasInitialPin = Boolean(latInput.value && lngInput.value);
        const initialLocation = {
          lat: parseFloat(latInput.value) || 25.2048,
          lng: parseFloat(lngInput.value) || 55.2708,
        };

        const map = new google.maps.Map(mapNode, {
          center: initialLocation,
          zoom: hasInitialPin ? 14 : 8,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          restriction: {
            latLngBounds: uaeBounds,
            strictBounds: false,
          },
        });

        const marker = new google.maps.Marker({
          map: hasInitialPin ? map : null,
          position: initialLocation,
          draggable: true,
        });

        const geocoder = new google.maps.Geocoder();
        const autocomplete = searchInput
          ? new google.maps.places.Autocomplete(searchInput, {
              componentRestrictions: { country: "ae" },
              fields: ["address_components", "formatted_address", "geometry", "name", "place_id"],
            })
          : null;

        window.lilyDeliveryMap = map;
        window.lilyDeliveryMarker = marker;

        const reverseGeocode = (location) => {
          geocoder.geocode({ location }, (results, status) => {
            if (status === "OK" && results && results[0]) {
              fillAddressFromPlace(form, results[0]);
              if (searchInput) searchInput.value = results[0].formatted_address || searchInput.value;
              syncDeliveryLocationBlock(form);
            }
          });
        };

        map.addListener("click", (event) => {
          const lat = event.latLng.lat();
          const lng = event.latLng.lng();
          if (setCoordinates(lat, lng, "Delivery pin saved.", "تم حفظ موقع التوصيل.")) {
            marker.setMap(map);
            marker.setPosition(event.latLng);
            reverseGeocode(event.latLng);
          }
        });

        marker.addListener("dragend", (event) => {
          const lat = event.latLng.lat();
          const lng = event.latLng.lng();
          if (setCoordinates(lat, lng, "Delivery pin saved.", "تم حفظ موقع التوصيل.")) {
            reverseGeocode(event.latLng);
          }
        });

        if (autocomplete) {
          autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (!place.geometry || !place.geometry.location) {
              setMapStatus(statusNode, "Choose a location from the Google suggestions.", "اختاري موقعاً من اقتراحات Google.", "error");
              return;
            }

            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            if (!setCoordinates(lat, lng, "Delivery pin saved.", "تم حفظ موقع التوصيل.")) return;

            if (placeIdInput) placeIdInput.value = place.place_id || "";
            fillAddressFromPlace(form, place);
            syncDeliveryLocationBlock(form);
            marker.setMap(map);
            marker.setPosition(place.geometry.location);
            map.setCenter(place.geometry.location);
            map.setZoom(14);
          });
        }

        setMapStatus(statusNode, "Search, click the map, or use your location to save a UAE delivery pin.", "ابحثي أو اضغطي على الخريطة أو استخدمي موقعك لحفظ موقع توصيل داخل الإمارات.");
      })
      .catch(() => {
        mapNode.classList.add("is-disabled");
        setMapStatus(
          statusNode,
          "Google Maps could not load. Manual address still works.",
          "تعذر تحميل خرائط Google. يمكن إدخال العنوان يدوياً."
        );
      });
  }

  function setupOrderPayload(form) {
    const noteInput = form.querySelector("[data-lily-order-note]");
    const fullPhoneInput = form.querySelector("[data-lily-full-phone]");

    const valueFor = (name) => {
      const fields = Array.from(form.elements).filter((field) => field.name === name);
      if (fields.length === 0) return "";

      if (fields[0].type === "radio") {
        const checkedField = fields.find((field) => field.checked);
        return normalizeDigits(checkedField?.value || "").trim();
      }

      return normalizeDigits(fields[0].value).trim();
    };

    const updatePayload = () => {
      const phoneCode = valueFor("attributes[Phone country code]");
      const phoneNumber = valueFor("attributes[Phone number]");
      const fullPhone = [phoneCode, phoneNumber].filter(Boolean).join(" ");
      if (fullPhoneInput) fullPhoneInput.value = fullPhone;

      if (!noteInput) return;

      const lat = valueFor("attributes[Latitude]");
      const lng = valueFor("attributes[Longitude]");

      const rows = [
        ["Customer name", valueFor("attributes[Customer name]")],
        ["Phone", fullPhone],
        ["Delivery date", valueFor("attributes[Delivery date]")],
        ["Delivery window", valueFor("attributes[Delivery window]")],
        ["House type", valueFor("attributes[House type]")],
        ["Building / villa", valueFor("attributes[Building or villa]")],
        ["Street", valueFor("attributes[Street]")],
        ["Floor", valueFor("attributes[Floor]")],
        ["Emirate", valueFor("attributes[Emirate]")],
        ["Postal code", valueFor("attributes[Postal code]")],
        ["Additional directions", valueFor("attributes[Additional directions]")],
        ["Google location", valueFor("attributes[Google location search]")],
        ["Google Maps link", valueFor("attributes[Google maps link]")],
        ["Latitude", lat],
        ["Longitude", lng],
      ].filter((row) => row[1]);

      noteInput.value = `Mesh Story delivery details\n${rows.map((row) => `${row[0]}: ${row[1]}`).join("\n")}`;
    };

    form.addEventListener("input", updatePayload);
    form.addEventListener("change", updatePayload);
    updatePayload();
    return updatePayload;
  }

  function setupCartDelivery() {
    document.querySelectorAll("[data-lily-cart-form]").forEach((form) => {
      setupDeliveryDateField(form);
      const updateAddressSummary = setupAddressSummary(form);
      const updateOrderPayload = setupOrderPayload(form);

      form.addEventListener("submit", () => {
        form.querySelectorAll("[data-normalize-digits]").forEach((field) => {
          field.value = normalizeDigits(field.value);
        });
        updateAddressSummary();
        updateOrderPayload();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    setupRootLandingFallback();
    setupLoadingScreen();
    normalizeCartLinks();
    setupFaviconFallback();
    setupStockTopbarCompatibility();
    setupLanguageSwitchers();
    setupMenuInteractions();
    setupFallbackPages();
    syncStorefrontLinks();
    applyStorefrontStatus(defaultStorefrontStatus);
    document.addEventListener("lily:language-change", () => applyStorefrontStatus(storefrontStatus));
    loadDeliveryScheduling();
    setupCategoryFilters();
    setupProductGalleries();
    setupChoiceGroups();
    setupVariantChoices();
    setupWholeWheatVariantPicker();
    setupInventoryGuards();
    setupStorefrontStatusGuards();
    setupAddOnPricing();
    setupDigitNormalization();
    setupQuantitySteppers();
    setupLandingFeaturedProducts();
    setupCartCheckoutDelivery();
    setupCartDelivery();
    applyLanguage(getInitialLanguage());
  });
})();
